/* eslint-disable */

// @ts-nocheck
export default function WireframeCssAssetDesktop() {
    return (
        <>
            <style
                jsx
                global
            >{`
                /* MAIN DECLARATIONS */
                /* html {
    height: 100%;
} */

                /* body {
    background-color: #FFFFFF;
    min-width: 1024px;
    position: relative;
    margin: 0;
    padding: 0;
    font-family: Verdana, Arial, Helvetica, sans-serif;
    font-size: 12px;
    line-height: 16px;
    color: #333333;
    height: 100%;
} */

                /* a {
    text-decoration: none;
    color: #0563C1;
    cursor: pointer;
} */

                /* a:hover {
    text-decoration: underline;
} */

                a.nohover:hover {
                    text-decoration: none;
                }

                /* img {
    border: 0;
} */

                /* form, fieldset {
    border: 0;
    margin: 0;
    padding: 0;
} */

                /* input, select, textarea {
    font-size: 12px;
    color: #333333;
} */

                /* input:focus, select:focus, textarea:focus, button:focus {
    outline: none;
} */

                /* CLEAR ELEMENTS */
                /* .clear {
    clear: both;
    display: block;
    overflow: hidden;
    visibility: hidden;
    width: 0;
    height: 0;
} */

                .clearfix:before,
                .clearfix:after {
                    content: '\\0020';
                    display: block;
                    overflow: hidden;
                    visibility: hidden;
                    width: 0;
                    height: 0;
                }

                .clearfix:after {
                    clear: both;
                }

                /* .clearfix {
    zoom: 1;
} */

                /* PAGE AND ADS */
                #c24-page-and-ads {
                    min-width: 1024px;
                    min-height: 100%;
                    position: relative;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -webkit-flex-direction: column;
                    -ms-flex-direction: column;
                    flex-direction: column;
                }

                #c24-ads {
                    width: 100%;
                    position: relative;
                    background: #0563c1;
                }

                #c24-ads-content {
                    width: 994px;
                    position: relative;
                    margin: 0 auto;
                }

                #c24-page-container-content {
                    text-align: center;
                    position: relative;
                    -webkit-flex: 1 0 auto;
                    -ms-flex: 1 0 auto;
                    flex: 1 0 auto;
                    min-width: 0;
                }

                .c24-page-container {
                    text-align: center;
                    width: 100%;
                }

                #c24-page-container-header,
                #c24-page-container-footer {
                    -webkit-flex: none;
                    -ms-flex: none;
                    flex: none;
                }

                .c24-page {
                    width: 100%;
                    padding: 0;
                    margin: 0 auto 0;
                    text-align: left;
                }

                div.c24-ad-banner {
                    width: 728px;
                    margin: 0 auto;
                }

                div.c24-ad-skyscraper {
                    position: absolute;
                    top: 233px;
                    left: 1010px;
                    z-index: 1;
                }

                div.c24-ad-rectangle {
                    float: right;
                    margin-left: 15px;
                    margin-bottom: 10px;
                    position: relative;
                    z-index: 99;
                }

                div.c24-ad-rectangle .ad {
                    color: #999;
                }

                .c24-blocking-layer,
                .c24-strict-blocking-layer {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 20000;
                    width: 100%;
                    min-height: 100%;
                    cursor: pointer;
                }

                .c24-strict-blocking-layer {
                    cursor: inherit;
                    position: fixed;
                }

                /* TRACKING */
                /* .c24-tracking {
    position: absolute;
    top: -10px;
    left: -10px;
} */

                /* .c24-gt {
    position: absolute;
    top: -10px;
} */

                iframe[name='google_conversion_frame'] {
                    height: 0 !important;
                    width: 0 !important;
                    line-height: 0 !important;
                    font-size: 0 !important;
                    margin-top: -13px;
                    float: left;
                }

                /* HEADER */
                #c24-header {
                    width: 100%;
                    min-height: 74px;
                }

                #c24-header,
                #c24-header * {
                    -webkit-text-size-adjust: none !important;
                }

                #c24-header a:focus-visible,
                #c24-header span:focus-visible,
                #c24-footer a:focus-visible,
                #c24-footer span:focus-visible {
                    outline: none;
                    box-shadow: 0 0 0 1px #fff;
                }

                .c24-header-inner {
                    color: #ffffff;
                    position: relative;
                }

                #c24-header-top {
                    background: #022d94;
                    height: 74px;
                    padding: 0 50px;
                }

                #c24-header-bottom {
                    background: #022d94;
                    height: 42px;
                    padding: 0 50px;
                }

                @media only screen and (max-width: 1280px) {
                    #c24-header-bottom,
                    #c24-header-top {
                        padding: 0 15px;
                    }
                }

                #c24-header-top .c24-header-content,
                #c24-header-bottom .c24-header-content {
                    position: relative;
                }
                #c24-header-top .c24-header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    width: 100%;
                    height: 74px;
                }

                .c24-header-inner a:hover {
                    text-decoration: underline;
                }

                .c24-header-components {
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    flex-grow: 1;
                }

                /* HEADER Logo */
                .c24-logo {
                    width: 155px;
                    height: 38px;
                    flex-shrink: 0;
                    margin-top: 12px;
                    padding: 8px 15px 8px 0;
                    background-size: 155px;
                    background-position: left center;
                    box-sizing: content-box;
                }

                .c24-logo,
                .c24-cc-logo,
                .c24-footer-logo {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-repeat: no-repeat;
                }

                /* HEADER Breadcrumb */
                #c24-breadcrumb {
                    background: #ffffff;
                    width: 100%;
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    padding: 15px 50px;
                }

                #c24-breadcrumb .c24-breadcrumb-content {
                    position: relative;
                    min-width: 994px;
                    width: 100%;
                    max-width: 1280px;
                    box-sizing: border-box;
                    padding-bottom: 10px;
                    font-size: 12px;
                    margin: 0 auto;
                }

                @media only screen and (max-width: 1280px) {
                    #c24-breadcrumb {
                        padding: 15px;
                    }
                }

                #c24-breadcrumb ul {
                    display: inline;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }

                #c24-breadcrumb ul li {
                    color: #0563c1;
                    display: inline;
                }

                #c24-breadcrumb ul li a.c24-breadcrumb-last {
                    cursor: default !important;
                    text-decoration: none !important;
                }

                /* FOOTER */
                .c24-footer,
                .c24-footer * {
                    -webkit-text-size-adjust: none !important;
                    box-sizing: border-box;
                }

                .c24-footer {
                    display: block;
                    width: 100%;
                    position: relative;
                }

                .c24-footer-top {
                    font-size: 14px;
                    line-height: 18px;
                }

                .c24-footer-jumptotop {
                    width: 100%;
                    text-align: center;
                    line-height: 50px;
                    font-size: 14px;
                    color: #fff;
                    background: #0563c1;
                    cursor: pointer;
                }
                .c24-footer-jumptotop:hover {
                    text-decoration: underline;
                }
                .c24-footer-links-wrapper {
                    background: #022d94;
                }
                .c24-footer-links-separator {
                    border-bottom: 1px solid #dcdcdc;
                    margin: 0 20px;
                }
                .c24-footer-links,
                .c24-footer-bottom-links {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    padding: 30px 0;
                }
                .c24-footer-bottom-links {
                    padding: 24px 0 16px;
                }
                .c24-footer-links ul,
                .c24-footer-bottom-links ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                .c24-footer-links ul {
                    margin-right: 39px;
                }
                .c24-footer-links .c24-footer-link-first-ele {
                    margin-right: 100px;
                    color: #ffffff;
                }
                .c24-footer-links-wrapper .c24-footer-link-first-ele .c24-footer-logo-wrapper {
                    padding-top: 0;
                }
                .c24-footer-links-wrapper .c24-footer-link-first-ele .c24-footer-logo {
                    width: 155px;
                    height: 38px;
                    margin: unset;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-terms-links {
                    display: unset;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-terms-links a {
                    margin-right: 5px;
                    margin-left: 5px;
                    color: #ffffff;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-terms-links a:first-child {
                    margin-left: 0;
                    font-weight: normal;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-logo-subline {
                    white-space: nowrap;
                    margin-top: 5px;
                    margin-bottom: 24px;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon-wrapper {
                    margin-top: 16px;
                    display: flex;
                    gap: 16px;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    overflow: hidden;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon:hover {
                    text-decoration: none;
                    color: unset;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon div {
                    background-repeat: no-repeat;
                    width: 32px;
                    height: 32px;
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-facebook-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxwYXRoIGQ9Ik0yNC42MzksMTYuNDRsLS4yNTIsMy4yMzZoLTMuMzQ0djEwLjc4OGgtMy45NTV2LTEwLjc4OGgtMi4xNTh2LTMuMjM2aDIuMTU4di0yLjA1YzAtLjkzNSwwLTIuMzczLjY4My0zLjI3Mi43MTktLjkzNSwxLjY5LTEuNTgyLDMuMzgtMS41ODIsMi43NjksMCwzLjkyLjM5NiwzLjkyLjM5NmwtLjUzOSwzLjIzNnMtLjk3MS0uMjUyLTEuNzk4LS4yNTJjLS44NjMsMC0xLjY1NC4zMjQtMS42NTQsMS4xNTF2Mi4zNzNzMy41NiwwLDMuNTYsMFoiIGZpbGw9IiM5OTkiIHN0cm9rZS13aWR0aD0iMCIvPjwvc3ZnPg==');
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-youtube-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxwYXRoIGQ9Ik0yOS44MiwxNS4wNjZjLS4yMzYtLjg4Mi0uOTMtMS41NzYtMS44MTItMS44MTItMS41OTktLjQyOC04LjAwOC0uNDI4LTguMDA4LS40MjgsMCwwLTYuNDA5LDAtOC4wMDguNDI4LS44ODIuMjM2LTEuNTc2LjkzLTEuODEyLDEuODEyLS40MjgsMS41OTktLjQyOCw0LjkzNC0uNDI4LDQuOTM0LDAsMCwwLDMuMzM1LjQyOCw0LjkzNC4yMzYuODgyLjkzLDEuNTc2LDEuODEyLDEuODEyLDEuNTk5LjQyOCw4LjAwOC40MjgsOC4wMDguNDI4LDAsMCw2LjQwOSwwLDguMDA4LS40MjguODgyLS4yMzYsMS41NzYtLjkzLDEuODEyLTEuODEyLjQyOC0xLjU5OS40MjgtNC45MzQuNDI4LTQuOTM0LDAsMCwwLTMuMzM1LS40MjgtNC45MzRaTTE4LjA1NywyMy4wNzR2LTYuMTQ5bDUuMzI1LDMuMDc0LTUuMzI1LDMuMDc0WiIgZmlsbD0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIwIi8+PC9zdmc+');
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-instagram-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjQuNjM0IiBmaWxsPSIjOTk5IiBzdHJva2Utd2lkdGg9IjAiLz48cGF0aCBkPSJNMjUuNzIzLDExLjE3OGgtMTEuNDQ2Yy0xLjcxMSwwLTMuMDk5LDEuMzg3LTMuMDk5LDMuMDk5djExLjQ0NmMwLDEuNzExLDEuMzg3LDMuMDk5LDMuMDk5LDMuMDk5aDExLjQ0NmMxLjcxMiwwLDMuMDk5LTEuMzg3LDMuMDk5LTMuMDk5di0xMS40NDZjMC0xLjcxMS0xLjM4OC0zLjA5OS0zLjA5OS0zLjA5OVpNMjAsMjYuMDM2Yy0zLjMzMywwLTYuMDM2LTIuNzAyLTYuMDM2LTYuMDM2czIuNzAyLTYuMDM2LDYuMDM2LTYuMDM2LDYuMDM2LDIuNzAyLDYuMDM2LDYuMDM2LTIuNzAzLDYuMDM2LTYuMDM2LDYuMDM2Wk0yNi4yMTEsMTQuNDU0Yy0uNjA0LDAtMS4wOTQtLjQ5LTEuMDk0LTEuMDk0cy40OS0xLjA5NCwxLjA5NC0xLjA5NCwxLjA5NC40OSwxLjA5NCwxLjA5NC0uNDksMS4wOTQtMS4wOTQsMS4wOTRaIiBmaWxsPSIjOTk5IiBzdHJva2Utd2lkdGg9IjAiLz48L3N2Zz4=');
                }
                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-tiktok-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxwYXRoIGQ9Ik0yMC40NDIsOS45MTNjMS4xMDMtLjAxNywyLjE5OC0uMDA4LDMuMjkyLS4wMTcuMDY3LDEuMjg4LjUzLDIuNjAyLDEuNDczLDMuNTExLjk0My45MzUsMi4yNzMsMS4zNjQsMy41NywxLjUwN3YzLjM5M2MtMS4yMTItLjA0Mi0yLjQzMy0uMjk1LTMuNTM2LS44MTctLjQ4LS4yMTktLjkyNi0uNDk3LTEuMzY0LS43ODMtLjAwOCwyLjQ1OS4wMDgsNC45MTctLjAxNyw3LjM2Ny0uMDY3LDEuMTc5LS40NTUsMi4zNDktMS4xMzcsMy4zMTctMS4xMDMsMS42MTctMy4wMTQsMi42NjktNC45NzYsMi43MDMtMS4yMDQuMDY3LTIuNDA4LS4yNjEtMy40MzUtLjg2Ny0xLjcwMS0xLjAwMi0yLjg5Ni0yLjgzNy0zLjA3My00LjgwOC0uMDE3LS40MjEtLjAyNS0uODQyLS4wMDgtMS4yNTUuMTUyLTEuNi45NDMtMy4xMzIsMi4xNzItNC4xNzYsMS4zOTgtMS4yMTIsMy4zNTEtMS43OTMsNS4xNzgtMS40NDguMDE3LDEuMjQ2LS4wMzQsMi40OTItLjAzNCwzLjczOC0uODM0LS4yNjktMS44MS0uMTk0LTIuNTQzLjMxMi0uNTMuMzQ1LS45MzUuODc2LTEuMTQ1LDEuNDczLS4xNzcuNDI5LS4xMjYuOTAxLS4xMTgsMS4zNTYuMjAyLDEuMzgxLDEuNTMyLDIuNTQzLDIuOTQ3LDIuNDE2Ljk0My0uMDA4LDEuODQ0LS41NTYsMi4zMzItMS4zNTYuMTYtLjI3OC4zMzctLjU2NC4zNDUtLjg5My4wODQtMS41MDcuMDUxLTMuMDA2LjA1OS00LjUxMy4wMDgtMy4zOTMtLjAwOC02Ljc3OC4wMTctMTAuMTYzaDBaIiBmaWxsPSIjOTk5IiBzdHJva2Utd2lkdGg9IjAiLz48L3N2Zz4=');
                }
                .c24-footer-links ul:last-child {
                    margin-right: 0;
                }
                .c24-footer-bottom-links ul {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    flex-wrap: wrap;
                    -webkit-flex-wrap: wrap;
                    white-space: nowrap;
                }
                .c24-footer-links ul li,
                .c24-footer-links ul li a,
                .c24-footer-links ul li a:hover,
                .c24-footer-bottom-links ul li,
                .c24-footer-bottom-links ul li a,
                .c24-footer-bottom-links ul li a:hover {
                    color: #fff;
                }
                .c24-footer-links ul li {
                    margin-top: 10px;
                }
                .c24-footer-links ul li:first-child {
                    font-weight: bold;
                    margin-top: 0;
                }
                .c24-footer-bottom-links ul li {
                    margin: 0 15px;
                }

                .c24-footer-slim-item {
                    display: none;
                }

                .c24-footer-bottom {
                    width: 100%;
                    background: #022d94;
                    color: #fff;
                    font-size: 12px;
                    line-height: 16px;
                }
                .c24-footer-logo-wrapper {
                    padding-top: 27px;
                }
                .c24-footer-logo {
                    display: block;
                    width: 89px;
                    height: 22px;
                    margin: 0 auto;
                }
                .c24-footer-copyright {
                    text-align: center;
                    padding: 0 15px 16px 15px;
                }
                .c24-footer:not(.c24-footer-slim) .c24-footer-copyright {
                    padding: 32px 15px;
                    font-size: 14px;
                }
                .c24-footer:not(.c24-footer-slim) .c24-footer-bottom-links {
                    display: none;
                }
                .c24-footer:not(.c24-footer-slim) .c24-footer-links {
                    padding: 30px 20px;
                }
                .c24-footer-slim .c24-footer-top,
                .c24-footer-slim .c24-footer-logo-wrapper {
                    display: none;
                }
                .c24-footer-slim .c24-footer-bottom {
                    background: #fff;
                    color: #333333;
                    padding-top: 16px;
                }
                .c24-footer-slim .c24-footer-bottom-links {
                    padding-top: 0;
                }
                .c24-footer-slim .c24-footer-bottom-links ul li a,
                .c24-footer-slim .c24-footer-bottom-links ul li a:hover {
                    color: #333333;
                }
                .c24-footer-slim .c24-footer-slim-item {
                    display: block;
                }

                @media (max-width: 1155px) {
                    .c24-footer-links .c24-footer-link-first-ele {
                        margin-right: 40px;
                    }
                }

                /* CONTENT ELEMENTS */
                .c24-hidden {
                    display: none;
                }

                .c24-first {
                    margin-left: 0 !important;
                }

                .c24-last {
                    margin-right: 0 !important;
                }

                .c24-web,
                .c24-ver,
                .c24-fin,
                .c24-tel,
                .c24-nrg,
                .c24-rsn,
                .c24-sho {
                    color: #333333;
                }

                .c24-web a,
                .c24-ver a,
                .c24-fin a,
                .c24-tel a,
                .c24-nrg a,
                .c24-rsn a,
                .c24-sho a {
                    color: #0563c1;
                }

                /* PRINT QUERY */
                @media print {
                    #c24-header-nav,
                    #c24-header-search,
                    #c24-header-tv,
                    #c24-breadcrumb,
                    #c24-footer-container,
                    #c24-ad-banner,
                    #c24-ad-skyscraper,
                    svg {
                        display: none;
                    }
                }

                .c24-points-msg {
                    display: inline-block;
                    color: #ffffff;
                    font-size: 16px;
                    line-height: 22px;
                    padding: 8px 5px 12px;
                    box-sizing: border-box;
                    position: absolute;
                    right: 135px;
                    bottom: 0;
                    text-decoration: none;
                }
                .c24-header-inner a.c24-points-msg:hover {
                    text-decoration: none;
                    color: #ffffff;
                }
                @media (max-width: 1880px) {
                    .c24-points-msg {
                        display: none;
                    }
                }

                .c24-header-payback-ele {
                    float: right;
                    width: 120px;
                    text-align: right;
                    margin: 3px 0 0 25px;
                }

                .c24-header-payback-ele-title {
                    display: block;
                    color: #ffffff;
                    font-size: 11px;
                }
                .c24-header-payback-ele svg {
                    width: 120px;
                    height: 47px;
                }

                input.c24-button,
                button.c24-button,
                a.c24-button,
                a.c24-cookie-button,
                a.c24-cookie-consent-button {
                    text-decoration: none !important;
                    font-size: 13px;
                    padding: 5px;
                    font-family: Arial, Helvetica, sans-serif;
                    cursor: pointer;
                    font-weight: bold;
                    border: 0 !important;
                    display: inline-block;
                    background: #0563c1;
                    background: -webkit-gradient(
                        linear,
                        left top,
                        left bottom,
                        color-stop(0%, rgba(5, 99, 193, 1)),
                        color-stop(100%, rgba(5, 99, 193, 1)),
                        color-stop(100%, rgba(5, 99, 193, 1))
                    ); /* Chrome,Safari4+ */
                    text-align: center;
                    vertical-align: middle;
                    color: #fff;
                    -webkit-border-radius: 3px;
                    -moz-border-radius: 3px;
                    border-radius: 3px;
                }

                .c24-header-placeholder {
                    display: none;
                    flex-grow: 1;
                }
                .c24-nosearch .c24-search {
                    display: none;
                }
                .c24-nosearch .c24-header-placeholder {
                    display: block;
                } /* DEPRECATED DECLARATIONS */

                /* MAIN CONTAINER */
                .c24-container-12 {
                    margin-bottom: 14px;
                    width: 994px;
                    padding: 15px 0 0;
                    background: #ffffff;
                }
                .c24-row {
                    margin-left: -7px;
                    margin-right: -7px;
                    box-sizing: border-box;
                    clear: both;
                }

                .c24-front {
                    z-index: 2;
                }

                /* AT Wireframe */
                #c24-header-at .c24-logo {
                    height: 41px;
                }

                #c24-header-at .c24-logo-text {
                    position: absolute;
                    bottom: -2px;
                    left: 0;
                    color: #ffffff;
                    font-size: 13px;
                }

                /* CONTENT ELEMENTS Columns and Boxes */
                .c24-cnt-ele {
                    margin-bottom: 32px;
                    position: relative;
                }

                /*.c24-cnt-ele, .c24-cnt-box { background-color: #ffffff; }*/
                .c24-cnt-ele-content {
                    padding: 0;
                }

                .c24-cnt-ele-title {
                    color: #333333;
                    font-size: 14px;
                    font-weight: normal;
                    margin: 0 0 10px;
                    border-bottom: 1px solid #dcdcdc;
                    padding-bottom: 10px;
                }

                .c24-cnt-ele-title a {
                    color: #333333;
                }

                .c24-flex-title {
                    display: block;
                    font-size: 23px;
                    font-weight: bold;
                    text-align: center;
                    margin: 0 0 45px 0;
                }

                .c24-cnt-ele-subtitle {
                    display: block;
                    font-size: 12px;
                    font-weight: normal;
                }

                .c24-cnt-ele-more {
                    border-top: 1px solid #dcdcdc;
                    text-align: right;
                    font-weight: bold;
                    padding: 2px 0;
                }

                .c24-dialog-box {
                    background-color: #ffffff;
                }

                .c24-cnt-ele-ver,
                .c24-cnt-ele-fin,
                .c24-cnt-ele-nrg,
                .c24-cnt-ele-tel,
                .c24-cnt-ele-rsn,
                .c24-cnt-ele-sho,
                .c24-cnt-ele-fhm,
                .c24-cnt-ele-plain {
                    background: #ffffff;
                }

                .c24-cntcol-sidebar,
                .c24-cntcol-content {
                    margin: 11px 0 0;
                }

                .c24-cntcol-container {
                    margin-bottom: 14px;
                    background-color: #fff;
                }

                .c24-cntcol-container .c24-cnt-ele {
                    border-radius: 0;
                    border: 0;
                    margin-bottom: 30px;
                }

                .c24-cntcol-content .c24-grid-9 {
                    width: 724px;
                }

                .c24-cntcol-content .c24-grid-9 .c24-grid-6 {
                    width: 478px;
                }

                .c24-cntcol-content .c24-grid-9 .c24-grid-4-5 {
                    width: 355px;
                }

                .c24-cntcol-content .c24-grid-9 .c24-grid-3 {
                    width: 232px;
                }

                .c24-cntcol-sidebar .c24-cnt-ele-title {
                    padding-bottom: 0;
                    border: none;
                }

                .c24-cnt-teaser {
                    min-height: 90px;
                    height: auto !important;
                    margin: 0 0 30px 0;
                }

                .c24-cnt-teaser .c24-cnt-teaser-img {
                    float: right;
                }

                .c24-cnt-teaser .c24-cnt-teaser-link {
                    padding-left: 130px;
                    margin-bottom: 0;
                }

                /* CONTENT ELEMENTS Tabbox */
                .c24-js-tb-tab {
                    display: none;
                }

                .c24-tab-group {
                    margin-bottom: 32px;
                }

                .c24-tab-navi {
                    z-index: 99;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    border-bottom: 1px solid #dcdcdc;
                    overflow: inherit;
                    visibility: inherit;
                    width: 100%;
                    display: block;
                }

                .c24-tab-navi li {
                    float: left;
                    display: block;
                }

                .c24-tab-navi li a {
                    display: block;
                    padding: 5px 0 7px 0;
                    text-align: center;
                    font-weight: normal;
                    color: #fff;
                    font-size: 14px;
                    width: 100%;
                }

                .c24-grid-12 .c24-tab-navi-3 li {
                    width: 330px !important;
                }

                .c24-grid-12 .c24-tab-navi-4 li {
                    width: 248px !important;
                }

                .c24-grid-12 .c24-tab-navi-4 li.last {
                    width: 250px !important;
                }

                .c24-grid-12 .c24-tab-navi-5 li {
                    width: 198px !important;
                }

                .c24-grid-12 .c24-tab-navi-6 li {
                    width: 164px !important;
                }

                .c24-grid-12 .c24-tab-navi-7 li {
                    width: 142px !important;
                }

                .c24-tab-navi li.last a {
                    margin-right: 0 !important;
                }

                .c24-tab-navi li a:hover,
                .c24-tab-navi li a.active {
                    text-decoration: none;
                    font-weight: bold;
                    position: relative;
                }

                .c24-grid-12 .c24-tab-navi-3 li a.active:after {
                    left: 154px;
                }

                .c24-grid-12 .c24-tab-navi-4 li a.active:after {
                    left: 113px;
                }

                .c24-grid-12 .c24-tab-navi-5 li a.active:after {
                    left: 88px;
                }

                .c24-grid-12 .c24-tab-navi-6 li a.active:after {
                    left: 71px;
                }

                .c24-grid-12 .c24-tab-navi-7 li a.active:after {
                    left: 60px;
                }

                .c24-tab-group-content {
                    z-index: 55;
                    padding: 22px 10px 10px;
                    background-color: #fff;
                    width: 994px;
                }

                .c24-tab-content ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }

                .c24-tab-content ul li {
                    height: 1%; /* ie6 fix */
                    margin-bottom: 10px;
                }

                .c24-tab-content h1,
                .c24-tab-content h2,
                .c24-tab-content h3,
                .c24-tab-content h4,
                .c24-tab-content h5,
                .c24-tab-content h6 {
                    color: #333333;
                    font-weight: bold;
                    font-size: 12px;
                    line-height: 16px;
                    margin-bottom: 7px;
                }

                .c24-cntcol-content .c24-tab-group-content {
                    border: none !important;
                }

                .c24-tab-navi li a {
                    display: block;
                    padding: 5px 0 9px 0;
                    text-align: center;
                    font-size: 15px;
                    color: #333333;
                    line-height: 19px;
                }

                .c24-tab-navi li .c24-tab-sem {
                    display: block;
                    padding: 5px 0 9px 0;
                    text-align: center;
                    font-size: 14px;
                    color: #333333;
                }

                .c24-tab-navi li .c24-tab-sem:hover,
                .c24-tab-navi li .c24-tab-sem.active {
                    color: #fff;
                    background-color: #ffffff !important;
                    text-decoration: none;
                    font-weight: bold !important;
                }

                .c24-tab-group-flex .c24-tab-navi {
                    width: 994px;
                    margin: 0 auto;
                }

                .c24-tab-group-flex .c24-tab-group-navi {
                    background-color: #0563c1;
                    width: 994px;
                }

                .c24-tab-group-flex .c24-tab-navi {
                    border: 0;
                }

                .c24-tab-group-flex .c24-tab-navi-7 li {
                    width: 142px;
                }

                .c24-tab-group-flex .c24-tab-navi li a {
                    display: block;
                    padding: 6px 0 7px 0;
                    text-align: center;
                    font-weight: normal;
                    color: #fff;
                    font-size: 15px;
                    width: 100%;
                }

                .c24-tab-group-flex .c24-tab-navi li a.active {
                    background-color: #51b2ff;
                    font-weight: bold;
                }

                .c24-tab-group-flex .c24-tab-navi li a.active:after {
                    background: none;
                }

                /* CONTENT ELEMENTS Buttons */
                button.c24-button,
                button.c24-button-xl,
                button.c24-button-xxl {
                    position: relative;
                }

                input.c24-button-xxl,
                a.c24-button-xxl {
                    font-size: 16px !important;
                    padding: 10px 16px !important;
                }

                input.c24-button-xxxl,
                a.c24-button-xxxl,
                span.c24-button-xxxl {
                    font-size: 17px !important;
                    height: 52px;
                    width: 160px;
                    font-family: Arial, Helvetica, sans-serif;
                    display: block;
                }

                a.c24-button-xxxl,
                span.c24-button-xxxl {
                    text-decoration: none !important;
                    font-size: 18px !important;
                    height: 18px;
                    padding: 20px 0 16px 0;
                    width: 160px;
                }

                input.c24-button:hover,
                button.c24-button:hover,
                button.c24-button-xl:hover,
                button.c24-button-xxl:hover,
                input.c24-button-xl:hover,
                input.c24-button-xxl:hover,
                input.c24-button-xxxl:hover,
                input.c24-button-s:hover,
                a.c24-button:hover,
                a.c24-button-xl:hover,
                a.c24-button-xxl:hover,
                a.c24-button-s:hover,
                a.c24-button-xxxl:hover,
                span.c24-button-xxxl:hover,
                input.c24-button:active,
                button.c24-button:active,
                button.c24-button-xl:active,
                button.c24-button-xxl:active,
                input.c24-button-xl:active,
                input.c24-button-xxl:active,
                input.c24-button-xxxl:active,
                input.c24-button-s:active,
                a.c24-button:active,
                a.c24-button-xl:active,
                a.c24-button-xxl:active,
                a.c24-button-s:active,
                a.c24-button-xxxl:active,
                span.c24-button-xxxl:active,
                a.c24-cookie-button:hover,
                a.c24-cookie-consent-button:not(.c24-cookie-consent-button-secondary):hover {
                    background: #064e9c;
                    color: #ffffff;
                    background: -webkit-gradient(
                        linear,
                        left top,
                        left bottom,
                        color-stop(0%, rgba(6, 78, 156, 1)),
                        color-stop(100%, rgba(6, 78, 156, 1)),
                        color-stop(100%, rgba(6, 78, 156, 1))
                    ); /* Chrome,Safari4+ */
                }

                input.c24-button-s,
                a.c24-button-s {
                    font-size: 11px !important;
                }

                a.c24-button-s {
                    display: block;
                }

                a.c24-button-pt {
                    text-decoration: none !important;
                    font-size: 20px !important;
                    padding: 19px 18px 8px;
                    height: 28px;
                    font-family: Arial, Helvetica, sans-serif;
                    cursor: pointer;
                    font-weight: bold;
                    border: 0 !important;
                    display: block;
                    background: #0563c1;
                    -moz-border-radius: 3px;
                    -webkit-border-radius: 3px;
                    border-radius: 3px;
                    text-align: center;
                    vertical-align: middle;
                    color: #fff;
                    margin: 0 0 15px 0;
                }

                a.c24-button-pt .product {
                    float: left;
                    text-align: left;
                    display: block;
                    font-weight: normal;
                }

                a.c24-button-pt .price {
                    float: right;
                    text-align: right;
                    display: block;
                }

                a.c24-button-pt:hover {
                    background: #015fa4;
                    color: #ffffff;
                }

                /* CONTENT ELEMENTS Bubble */
                .c24-bubble {
                    width: 110px;
                    height: 110px;
                    display: block;
                    background: #e30613;
                    -webkit-border-radius: 55px;
                    -moz-border-radius: 55px;
                    border-radius: 55px;
                    position: absolute;
                    z-index: 4;
                }

                .c24-bubble-content {
                    display: block;
                    position: absolute;
                    width: 100%;
                    clear: both;
                }

                .c24-bubble-text {
                    display: block;
                    line-height: 22px;
                    font-size: 19px;
                    color: #ffffff;
                    margin-top: 16px;
                    -webkit-font-smoothing: antialiased;
                    font-weight: normal;
                }

                .c24-bubble-text div,
                .c24-bubble-text span {
                    display: block;
                    font-weight: normal;
                    text-align: center;
                    width: 100%;
                    float: left;
                    -webkit-font-smoothing: antialiased;
                }

                .c24-bubble-text div span,
                .c24-bubble-text span span {
                    font-weight: bold;
                    font-size: 26px;
                    line-height: 27px;
                    -webkit-font-smoothing: antialiased;
                }

                .c24-bubble-infoicon {
                    width: 10px;
                    height: 10px;
                    line-height: 10px;
                    text-align: center;
                    position: absolute;
                    top: 67px;
                    left: 88px;
                }

                .c24-bubble-text.c24-bubble-date {
                    margin-top: 26px;
                }

                .c24-bubble-text.c24-bubble-cashback {
                    margin-top: 18px;
                }

                .c24-bubble-text.c24-bubble-cashback .c24-cashback {
                    margin-top: -5px;
                    font-size: 14px;
                    display: block;
                    font-weight: normal;
                }

                .c24-bubble-infoicon {
                    vertical-align: top;
                    width: 10px;
                    height: 10px;
                    color: #ffffff;
                    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEwMCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTUwLDBDMjIuNCwwLDAsMjIuNCwwLDUwczIyLjQsNTAsNTAsNTBzNTAtMjIuNCw1MC01MFM3Ny42LDAsNTAsMHogTTU5LDg2SDQxVjM2aDE4Vjg2eiBNNTAsMzFMNTAsMzEgYy01LjgsMC05LjQtMy44LTkuNC04LjZjMC01LjEsMy43LTguNyw5LjQtOC43czkuMywzLjYsOS40LDguN0M1OS40LDI3LjEsNTUuNywzMSw1MCwzMXoiLz4NCjwvc3ZnPg0K')
                        center;
                    background-size: contain;
                }

                /* CONTENT ELEMENTS Lists */
                ul,
                .c24-list {
                    list-style: square;
                    padding-left: 20px;
                }

                .c24-tab-content .c24-list {
                    list-style: square !important;
                    padding-left: 20px !important;
                }

                .c24-list-blank {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                .c24-list-nav,
                .c24-list-subnav {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }

                .c24-list-nav ul {
                    list-style: none;
                }

                .c24-list-subnav li {
                    padding-left: 10px;
                }

                .c24-list-nav li a,
                .c24-list-subnav li a,
                .c24-list-nav li span,
                .c24-list-subnav li span {
                    padding: 4px 0 4px 0;
                    display: block;
                    font-weight: normal;
                }

                .c24-list-nav li span,
                .c24-list-subnav li span {
                    color: #005ea8;
                }

                .c24-list-nav li a.active,
                .c24-list-nav li span.active {
                    font-weight: bold;
                }

                .c24-cntcol-sidebar .c24-list-nav li a.active,
                .c24-cntcol-sidebar .c24-list-nav li span.active {
                    background: none;
                    position: relative;
                }

                .c24-cntcol-sidebar .c24-list-nav .c24-list-subnav li a.active:after {
                    background: none;
                }

                .c24-cntcol-sidebar .c24-list-subnav li a.active {
                    padding: 3px 0 3px 15px;
                    display: block;
                    font-weight: bold;
                    background: none;
                    margin-left: 0;
                }

                .c24-list-link {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                .c24-list-link li {
                    float: left;
                    font-weight: bold;
                }

                .c24-list-hakerl,
                .c24-list-plain,
                .c24-list-hakerl-grey,
                .c24-list-hakerl-flat-grey,
                .c24-list-haken,
                .c24-list-haken-s {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }

                .c24-list-plain li {
                    margin-bottom: 5px;
                }

                .c24-list-warning li {
                    background-position: -537px -64px;
                }

                .c24-list-hakerl li.last,
                .c24-list-hakerl-grey li.last {
                    margin-bottom: 0;
                }

                .c24-list-logo {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }

                .c24-list-logo li {
                    float: left;
                }

                ul.c24-list-num {
                    list-style: none;
                    margin: 0 0 0 3px;
                    padding: 0;
                }

                ul.c24-list-num li {
                    list-style: none;
                    line-height: 18px;
                    padding-left: 25px;
                    margin-bottom: 5px;
                }

                ol.c24-list-num {
                    padding-left: 15px;
                    margin: 0;
                }

                ol.c24-list-num li {
                    line-height: 18px;
                    margin-bottom: 5px;
                }

                .c24-list-haken li,
                .c24-list-hakerl li {
                    font-size: 14px;
                    line-height: 22px;
                    color: #333333;
                    margin-top: 10px;
                    position: relative;
                    padding-left: 23px;
                }

                .c24-list-haken-s li {
                    font-size: 11px;
                    line-height: 16px;
                    color: #333333;
                    margin-top: 4px;
                    position: relative;
                    padding-left: 17px;
                }

                .c24-list-haken li:first-child,
                .c24-list-hakerl li:first-child,
                .c24-list-haken-s li:first-child {
                    margin-top: 0;
                }

                .c24-list-haken li:before,
                .c24-list-hakerl li:before,
                .c24-list-haken-s li:before {
                    display: inline-block;
                    position: absolute;
                    left: 0;
                    content: ' ';
                    top: 4px;
                    width: 18px;
                    height: 22px;
                    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMjhweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyOCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggaWQ9ImNoZWNrX2dyZWVuIiBmaWxsPSIjMDA1RUE4IiBkPSJNMTA4LjEsMEw0OCw2MC4xTDIwLDMyTDAsNTJsNDgsNDhsODAtODBMMTA4LjEsMHoiLz4NCjwvc3ZnPg0K')
                        no-repeat;
                    background-size: 18px;
                }

                .c24-list-haken-s li:before {
                    font-size: 14px;
                    line-height: 16px;
                }

                .c24-list-blank li:before {
                    background: none;
                }

                .c24-list-navi-service {
                    list-style: none;
                    padding: 0 !important;
                    margin: 0 15px 0 0;
                    float: left;
                    border-right: 1px solid #dcdcdc;
                    width: 227px;
                    height: 100%;
                }

                .c24-list-navi-service li span {
                    font-weight: bold;
                    color: #005ea8;
                }

                .c24-list-navi-service li {
                    line-height: 22px;
                }

                ul.c24-last {
                    border: none;
                    margin-right: 0;
                }

                /* CONTENT ELEMENTS forms and form-elements */
                .c24-form-text,
                .c24-form-select,
                .c24-form-date {
                    border: 1px solid #b4b4b4;
                }

                .c24-form-error {
                    border-color: red;
                }

                .c24-form-text-large {
                    border: 1px solid #b4b4b4;
                    padding: 6px 4px 7px 4px;
                }

                .c24-form-select-large {
                    border: 1px solid #b4b4b4;
                    padding: 5px 4px 6px 4px;
                    line-height: 24px;
                    height: 30px;
                }

                /* input, select {
    font-family: Verdana, Arial, sans-serif;
    line-height: normal;
    font-size: 12px;
} */

                input {
                    padding: 2px;
                }

                select {
                    padding: 1px;
                }

                .c24-form input[type='radio'] {
                    width: 16px;
                    margin: 0;
                    padding: 0;
                    font-size: 8px;
                    opacity: 0;
                }

                .c24-form input[type='radio'] + label {
                    display: inline-block;
                    margin-left: -19px;
                    line-height: 24px;
                }

                .c24-form input[type='radio'] + label > span {
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    margin: 3px;
                    border: 2px solid #dcdcdc;
                    border-radius: 9px;
                    background: #ffffff;
                    vertical-align: bottom;
                }

                .c24-form input[type='radio']:checked + label > span {
                    background: #ffffff;
                    border: 2px solid #005ea8;
                }

                .c24-form input[type='radio']:checked + label > span > span {
                    display: block;
                    width: 8px;
                    height: 8px;
                    margin: 2px;
                    border: 1px solid #005ea8;
                    border-radius: 6px;
                    background: #005ea8;
                }

                .c24-form .label {
                    display: inline-block;
                    cursor: pointer;
                    position: relative;
                    padding-left: 27px;
                    margin-right: 15px;
                    font-size: 14px;
                    line-height: 24px;
                }

                .c24-form input[type='checkbox'] {
                    display: none;
                }

                .c24-form .label:before {
                    content: '';
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    left: 0;
                    bottom: 4px;
                    background-color: #ffffff;
                    border: 2px solid #b4b4b4;
                    box-sizing: border-box;
                }

                .c24-form .label:hover:before {
                    border: 2px solid #333333;
                }

                .c24-form input[type='checkbox']:checked + label:before {
                    background: #005ea8
                        url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMjhweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyOCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggaWQ9ImNoZWNrX2dyZWVuIiBmaWxsPSIjZmZmIiBkPSJNMTA4LjEsMEw0OCw2MC4xTDIwLDMyTDAsNTJsNDgsNDhsODAtODBMMTA4LjEsMHoiLz4NCjwvc3ZnPg0K')
                        no-repeat center;
                    background-size: contain;
                    border: 2px solid #005ea8;
                    width: 18px;
                    height: 18px;
                }

                .c24-form input[type='checkbox']:checked:disabled + label:before {
                    cursor: not-allowed;
                    background: #005ea8
                        url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMjhweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyOCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggaWQ9ImNoZWNrX2dyZWVuIiBmaWxsPSIjZmZmIiBkPSJNMTA4LjEsMEw0OCw2MC4xTDIwLDMyTDAsNTJsNDgsNDhsODAtODBMMTA4LjEsMHoiLz4NCjwvc3ZnPg0K')
                        no-repeat center;
                    background-size: contain;
                    border: 2px solid #666666;
                    width: 18px;
                    height: 18px;
                }

                .c24-form input[type='checkbox']:disabled + label {
                    cursor: not-allowed;
                }

                .c24-fe-radio input[type='radio'] {
                    opacity: 0;
                    position: absolute;
                    left: -1500px;
                }

                .c24-fe-radio input[type='radio'] + label > .c24-radio-text {
                    display: inline-block;
                    float: left;
                    font-size: 13px;
                    line-height: 16px;
                    margin-left: 9px;
                    width: 90%;
                }

                .c24-fe-radio:hover input[type='radio'] + label > .c24-radio-text {
                    color: #333333;
                }

                .c24-fe-radio input[type='radio'] + label > span.c24-radio-btn {
                    background: #fff none repeat scroll 0 0;
                    border: 2px solid #aaaaaa;
                    border-radius: 9px;
                    display: inline-block;
                    float: left;
                    height: 14px;
                    margin: 0;
                    vertical-align: top;
                    width: 14px;
                }

                .c24-fe-radio:hover input[type='radio'] + label > span.c24-radio-btn {
                    border: 2px solid #919191;
                }

                .c24-fe-radio input[type='radio']:checked + label > span.c24-radio-btn {
                    border: 2px solid #005ea8;
                }

                .c24-fe-radio input[type='radio']:checked + label > span.c24-radio-btn > span {
                    background: #005ea8 none repeat scroll 0 0;
                    border-radius: 4px;
                    display: block;
                    height: 8px;
                    margin: 3px 0 0 3px;
                    width: 8px;
                }

                .c24-fe-radio input[type='radio']:checked + label {
                    cursor: pointer;
                }

                .c24-fe-radio label {
                    cursor: pointer;
                }

                .c24-fe-radio.inline {
                    display: inline-block;
                    float: left;
                }

                .c24-fe-radio.boxed {
                    margin-right: 0;
                    display: table-cell;
                    border: 1px solid #b4b4b4;
                    box-sizing: border-box;
                    border-collapse: collapse;
                    width: 50%;
                    float: left;
                    background-color: #ffffff;
                }

                .c24-fe-radio.boxed:hover {
                    border: 1px solid #333333;
                    color: #005ea8 !important;
                }

                .c24-fe-radio.boxed label {
                    display: block;
                    padding: 11px 0 11px 9px;
                    margin: 0;
                    width: 100%;
                    box-sizing: border-box;
                    color: #333333;
                }

                .c24-fe-radio.boxed input[type='radio'] + label > .c24-radio-text {
                    width: 78%;
                    overflow: hidden;
                    font-weight: normal;
                    font-size: 16px !important;
                    line-height: 20px;
                }

                .c24-form-evo label {
                    display: block;
                    width: 100%;
                    padding: 0 0 6px;
                    line-height: 16px;
                    font-size: 14px;
                    font-weight: bold;
                    color: #005ea8;
                }

                .c24-form-evo .c24-input-evo {
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    appearance: none;
                    display: block;
                    width: 100%;
                    height: 44px;
                    padding: 10px 5px;
                    margin: 0;
                    box-sizing: border-box;
                    border: 1px solid #b4b4b4;
                    line-height: 24px;
                    font-size: 16px;
                    box-shadow: none;
                    border-radius: 0;
                    background-color: #ffffff;
                    font-family: Verdana, Arial, Helvetica, sans-serif;
                }

                .c24-form-evo .c24-select-evo {
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    appearance: none;
                    display: block;
                    width: 100%;
                    height: 44px;
                    padding: 0 20px 0 5px;
                    margin: 0;
                    box-sizing: border-box;
                    border: 1px solid #b4b4b4;
                    line-height: 24px;
                    font-size: 16px;
                    background: #fff
                        url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMTEuM3B4IiBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMjExLjMgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMTEuMyAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBvbHlnb24gZmlsbD0iI0I0QjRCNCIgcG9pbnRzPSIwLDAgMTA1LjcsMTAwIDIxMS4zLDAgIi8+DQo8L3N2Zz4NCg==')
                        no-repeat right 10px center;
                    background-size: 15px;
                    border-radius: 0;
                    font-family: Verdana, Arial, Helvetica, sans-serif;
                }

                .c24-category-teaser .c24-form-evo .c24-select-evo {
                    font-size: 18px;
                    padding: 5px 25px 5px 10px;
                    height: 52px;
                    border: 1px solid #b4b4b4;
                }

                .c24-category-teaser .c24-form-evo .c24-select-evo:active,
                .c24-category-teaser .c24-form-evo .c24-select-evo:focus {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMTEuM3B4IiBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMjExLjMgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMTEuMyAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBvbHlnb24gZmlsbD0iIzAwNUVBOCIgcG9pbnRzPSIwLDAgMTA1LjcsMTAwIDIxMS4zLDAgIi8+DQo8L3N2Zz4NCg==');
                }

                .c24-form-evo .c24-select-evo::-ms-expand {
                    display: none;
                }

                .c24-form-evo .c24-input-evo:hover,
                .c24-form-evo .c24-select-evo:hover {
                    border: 1px solid #333333 !important;
                }

                .c24-form-evo .c24-input-evo:active,
                .c24-form-evo .c24-input-evo:focus,
                .c24-form-evo .c24-select-evo:active,
                .c24-form-evo .c24-select-evo:focus {
                    border: 1px solid #005ea8 !important;
                }

                .c24-form-evo .c24-select-evo:active,
                .c24-form-evo .c24-select-evo:focus {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMTEuM3B4IiBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMjExLjMgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMTEuMyAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBvbHlnb24gZmlsbD0iIzAwNUVBOCIgcG9pbnRzPSIwLDAgMTA1LjcsMTAwIDIxMS4zLDAgIi8+DQo8L3N2Zz4NCg==');
                }

                .c24-form-evo .c24-rkr-select:active,
                .c24-form-evo .c24-rkr-select:focus {
                }

                .c24-form-evo .c24-input-wrapper {
                    position: relative;
                }

                .c24-form-evo .c24-input-delete {
                    height: 30px;
                    width: 30px;
                    position: absolute;
                    top: 34px;
                    right: -5px;
                    display: none;
                }

                /* CONTENT ELEMENTS IN HOME SLIDER forms and form-elements */
                .c24-home-slide .c24-singleline .c24-form-evo label {
                    font-size: 16px;
                }

                .c24-home-slide .c24-singleline .c24-form-evo .c24-input-evo {
                    font-size: 18px;
                    height: 52px;
                    border: 1px solid #b4b4b4;
                    padding: 5px 25px 5px 10px;
                }

                .c24-home-slide .c24-singleline .c24-form-evo .c24-select-evo {
                    font-size: 18px;
                    padding: 5px 25px 5px 10px;
                    height: 52px;
                    border: 1px solid #b4b4b4;
                }

                .c24-home-slide .c24-singleline .c24-form-evo .c24-select-evo:active,
                .c24-home-slide .c24-singleline .c24-form-evo .c24-select-evo:focus {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMTEuM3B4IiBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMjExLjMgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMTEuMyAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBvbHlnb24gZmlsbD0iIzAwNUVBOCIgcG9pbnRzPSIwLDAgMTA1LjcsMTAwIDIxMS4zLDAgIi8+DQo8L3N2Zz4NCg==');
                }

                .c24-home-slide .c24-singleline .c24-form-evo .c24-mob-model.c24-select-evo {
                    height: 44px;
                    padding-right: 32px;
                    font-size: 16px;
                }

                input#c24-rkr-credit-amount[type='text']::-ms-clear {
                    display: none;
                }

                select.c24-rkr-select:focus::-ms-value {
                    color: #333333;
                    background: transparent;
                }

                .c24-home-slide #c24-mof-form label {
                    font-size: 14px;
                }

                /* CONTENT ELEMENTS Misc */
                .c24-nav-blocking-layer,
                .c24-nav-blocking-layer-header {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0);
                    z-index: 900;
                    display: none;
                }

                .c24-nav-blocking-layer-footer {
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0);
                    z-index: 900;
                    display: none;
                }

                .cct-teaser.c24-cnt-ele {
                    border: 1px solid #dcdcdc;
                    box-sizing: border-box;
                }

                .c24-banderole {
                    display: inline-block;
                    font-size: 13px;
                    font-weight: bold;
                    line-height: 16px;
                    padding: 5px 10px 7px;
                    position: absolute;
                    top: 10px;
                    right: -8px;
                    background-color: #7ab51d;
                    color: #ffffff;
                }

                .c24-banderole:before {
                    border-left: 8px solid #6ca51f;
                    border-right: 8px solid transparent;
                    border-bottom: 8px solid transparent;
                    height: 0;
                    position: absolute;
                    right: -8px;
                    top: 28px;
                    width: 0;
                    content: '';
                }

                /* CONTENT ELEMENTS Saving */
                /*.c24-saving-hover { position:absolute; top:0px; right:0px; width:139px; height:136px; background-color:transparent;}*/
                .c24-contrast-saving-hover {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 139px;
                    height: 136px;
                    background-color: transparent;
                }

                .c24-contrast-saving-hover.c24-bubblefix {
                    top: 50px;
                    right: 0;
                }

                .c24-saving-box {
                    visibility: hidden;
                    position: absolute;
                    top: 50%;
                    right: 50%;
                    background-color: #ffffff;
                    border: 1px solid #005ea8;
                    width: 500px;
                    z-index: 99;
                    font-size: 11px;
                    color: #333333;
                    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.45);
                    margin-right: 71px;
                    margin-top: -79px;
                }

                .c24-saving-box-content {
                    padding: 10px;
                    position: relative;
                }

                .c24-saving-box-corner {
                    position: absolute;
                    top: -20px;
                    right: 19px;
                    width: 0;
                    height: 0;
                    border-left: 20px solid transparent;
                    border-right: 20px solid transparent;
                    border-bottom: 20px solid #dcdcdc;
                }

                .c24-saving-box-corner:before {
                    content: '';
                    position: absolute;
                    top: 1px;
                    right: -19px;
                    width: 0;
                    height: 0;
                    border-left: 19px solid transparent;
                    border-right: 19px solid transparent;
                    border-bottom: 19px solid #fff;
                }

                .c24-saving-box-corner_bottom {
                    position: absolute;
                    bottom: -20px;
                    right: 19px;
                    width: 0;
                    height: 0;
                    border-left: 20px solid transparent;
                    border-right: 20px solid transparent;
                    border-bottom: 20px solid #dcdcdc;
                    -webkit-transform: rotate(180deg);
                    -moz-transform: rotate(180deg);
                    -ms-transform: rotate(180deg);
                    -o-transform: rotate(180deg);
                    transform: rotate(180deg);
                }

                .c24-saving-box-corner_bottom:before {
                    content: '';
                    position: absolute;
                    top: 1px;
                    right: -19px;
                    width: 0;
                    height: 0;
                    border-left: 19px solid transparent;
                    border-right: 19px solid transparent;
                    border-bottom: 19px solid #fff;
                }

                .c24-saving-box-corner_right {
                    position: absolute;
                    bottom: -20px;
                    right: -30px;
                    width: 0;
                    height: 0;
                    border-left: 20px solid transparent;
                    border-right: 20px solid transparent;
                    border-bottom: 20px solid #005ea8;
                    -webkit-transform: rotate(90deg);
                    -moz-transform: rotate(90deg);
                    -ms-transform: rotate(90deg);
                    -o-transform: rotate(90deg);
                    transform: rotate(90deg);
                }

                .c24-saving-box-corner_right:before {
                    content: '';
                    position: absolute;
                    top: 1px;
                    right: -19px;
                    width: 0;
                    height: 0;
                    border-left: 19px solid transparent;
                    border-right: 19px solid transparent;
                    border-bottom: 19px solid #fff;
                }

                .c24-contrast-saving-hover .c24-saving-box-corner_right {
                    position: absolute;
                    bottom: -20px;
                    right: -16px;
                    width: 0;
                    height: 0;
                    border-top: 15px solid transparent;
                    border-bottom: 15px solid transparent;
                    border-left: 15px solid #005ea8;
                    border-right: none;
                    transform: none;
                }

                .c24-contrast-saving-hover .c24-saving-box-corner_right:before {
                    content: '';
                    position: absolute;
                    top: -14px;
                    right: 2px;
                    width: 0;
                    height: 0;
                    border-top: 14px solid transparent;
                    border-bottom: 14px solid transparent;
                    border-left: 14px solid #fff;
                    border-right: none;
                }

                .c24-saving-box-corner_left {
                    position: absolute;
                    top: 54px;
                    left: -30px;
                    width: 0;
                    height: 0;
                    border-left: 20px solid transparent;
                    border-right: 20px solid transparent;
                    border-bottom: 20px solid #dcdcdc;
                    -webkit-transform: rotate(-90deg);
                    -moz-transform: rotate(-90deg);
                    -ms-transform: rotate(-90deg);
                    -o-transform: rotate(-90deg);
                    transform: rotate(-90deg);
                }

                .c24-saving-box-corner_left:before {
                    content: '';
                    position: absolute;
                    top: 1px;
                    right: -19px;
                    width: 0;
                    height: 0;
                    border-left: 19px solid transparent;
                    border-right: 19px solid transparent;
                    border-bottom: 19px solid #fff;
                }

                .c24-contrast-saving-hover .c24-saving-box-corner_left {
                    position: absolute;
                    top: 184px;
                    left: -23px;
                    width: 0;
                    height: 0;
                    border-left: 15px solid transparent;
                    border-right: 15px solid transparent;
                    border-bottom: 15px solid #005ea8;
                    -webkit-transform: rotate(-90deg);
                    -moz-transform: rotate(-90deg);
                    -ms-transform: rotate(-90deg);
                    -o-transform: rotate(-90deg);
                    transform: rotate(-90deg);
                }

                .c24-contrast-saving-hover .c24-saving-box-corner_left:before {
                    content: '';
                    position: absolute;
                    top: 2px;
                    right: -14px;
                    width: 0;
                    height: 0;
                    border-left: 14px solid transparent;
                    border-right: 14px solid transparent;
                    border-bottom: 14px solid #fff;
                }

                .c24-saving-box-close {
                    position: absolute;
                    top: 0;
                    right: 0;
                    height: 40px;
                    width: 40px;
                    cursor: pointer;
                    z-index: 700;
                }

                .c24-saving-box-close {
                    position: absolute;
                    top: 9px;
                    right: 9px;
                    height: 16px;
                    width: 16px;
                    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEwMCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBvbHlnb24gZmlsbD0iIzU3NTc1NyIgcG9pbnRzPSIxMDAsODAgNzAsNTAgMTAwLDIwIDgwLDAgNTAsMzAgMjAsMCAwLDIwIDMwLDUwIDAsODAgMjAsMTAwIDUwLDcwIDgwLDEwMCAiLz4NCjwvc3ZnPg0K')
                        no-repeat;
                    background-size: cover;
                }

                .c24-saving-graph-content {
                    width: 100%;
                    position: relative;
                    padding-top: 60px;
                    height: 70px;
                }

                .c24-saving-graph {
                    height: 10px;
                    background: #599743;
                    position: relative;
                    border-radius: 4px 0 0 4px;
                }

                .c24-saving-label {
                    display: inline-block;
                    max-width: 200px;
                    border: 1px solid red;
                    color: red;
                    box-sizing: border-box;
                    background: #ffffff;
                    position: absolute;
                    top: -64px;
                    line-height: 16px;
                }

                .c24-saving-min {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 10px;
                    background: #005ea8;
                    border-radius: 4px 0 0 4px;
                }

                .c24-saving-min-label {
                    border: 1px solid #005ea8;
                    color: #005ea8;
                }

                .c24-saving-min-bar,
                .c24-saving-max-bar {
                    height: 20px;
                    width: 5px;
                    position: absolute;
                    z-index: 100;
                    top: -5px;
                }

                .c24-saving-min-bar {
                    background-color: #005ea8;
                }

                .c24-saving-max-bar {
                    background-color: #ff0000;
                    right: -2px;
                }

                .c24-saving-content {
                    padding: 6px;
                    text-align: center;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .c24-saving-corner {
                    position: absolute;
                    width: 0;
                    padding: 0 5px;
                    height: 8px;
                    bottom: -8px;
                }

                .c24-saving-total {
                    color: #599743;
                    text-align: center;
                    margin-top: 9px;
                    display: inline-block;
                    position: relative;
                }

                .c24-saving-corner:before {
                    border-left: 9px solid transparent;
                    border-right: 9px solid transparent;
                    border-top: 9px solid #005ea8;
                    height: 0;
                    position: absolute;
                    bottom: -1px;
                    left: -4px;
                    width: 0;
                    content: '';
                    z-index: 5050;
                }

                .c24-saving-corner:after {
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                    border-top: 8px solid #ffffff;
                    height: 0;
                    position: absolute;
                    bottom: 0;
                    left: -3px;
                    width: 0;
                    content: '';
                    z-index: 5050;
                }

                .c24-saving-max-corner:before {
                    border-top: 9px solid red;
                }

                /* CONTENT ELEMENTS broker notification */
                .c24-broker-info {
                    max-height: 36px;
                    display: none;
                }

                .c24-broker-info-cnt {
                    line-height: 16px;
                    padding: 10px 0;
                    text-align: center;
                    color: #333333;
                    background: #ffffff;
                }

                .c24-broker-info span {
                    font-size: 12px;
                }

                .c24-broker-info a {
                    text-decoration: underline;
                }

                .c24-broker-info-show {
                    display: block;
                }

                .c24-header-hover .c24-phone-list {
                    font-family: Verdana, Arial, Helvetica, sans-serif;
                    margin-top: 11px;
                }

                .c24-header-hover .c24-phone-list ul {
                    margin: 0;
                    padding: 0;
                }

                .c24-header-hover .c24-phone-list ul li {
                    display: block;
                    margin-bottom: 6px;
                    padding-bottom: 2px;
                    border-bottom: 1px solid #dcdcdc;
                }

                .c24-header-hover .c24-phone-list ul li a {
                    color: #005ea8;
                    font-size: 14px;
                    text-align: right;
                    display: block;
                }

                .c24-header-hover .c24-phone-list ul li.c24-space .c24-product-headline {
                    padding-top: 9px;
                }

                .c24-header-hover .c24-phone-list .c24-space {
                    border: none;
                    margin-bottom: 18px;
                }

                .c24-header-hover .c24-product-headline {
                    font-size: 12px;
                    font-weight: bold;
                    line-height: 14px;
                    display: block;
                }

                .c24-header-hover .c24-product-layer {
                    width: 50%;
                    float: left;
                }

                .c24-header-hover .c24-product-layer p {
                    margin: 0;
                    font-size: 12px;
                }

                .c24-ca-websec-siegel {
                    width: 910px;
                    height: 73px;
                    overflow: hidden;
                }

                .ca-wrapper .ca-item {
                    width: 228px;
                }

                .c24-ca-websec-bestseller .ca-wrapper {
                    /*width: 900px;*/
                    width: 100%;
                    height: 100%;
                    position: relative;
                    overflow: hidden;
                    margin: 0 auto;
                }

                .container-awards {
                    background: #2d93e2;
                    padding-top: 45px;
                    padding-bottom: 55px;
                }

                .container-awards-inner {
                    width: 994px;
                    margin: 0 auto;
                }

                .container-awards .c24-flex-title {
                    color: #ffffff;
                    margin-bottom: 55px;
                    font-size: 34px;
                }

                .container-awards .c24-award-box .c24-title {
                    color: #ffffff;
                    font-weight: normal;
                }

                .c24-bubble-container {
                    position: absolute;
                    left: inherit;
                    top: 40px;
                    width: 110px;
                    height: 110px;
                    right: 5px;
                    cursor: pointer;
                }

                .c24-bubblefix .c24-bubble-container {
                    top: 0;
                    right: 0;
                }

                .c24-bubble-container .c24-bubble-headline.bold {
                    font-weight: bold;
                    font-size: 30px;
                }

                .c24-bubble-container .c24-bubble-subheadline {
                    font-weight: normal;
                    font-size: 17px;
                    line-height: 16px;
                    display: block;
                }

                .c24-bubble-container-hover {
                    position: relative;
                }

                .c24-teaser-slider-widget .c24-singleline {
                    margin: 0 auto;
                }

                a.c24-btn-large,
                .btn-button.c24-btn-large,
                .c24-btn-large {
                    padding: 9px 56px;
                    font-size: 16px;
                }

                .c24-line {
                    border: 1px solid #dcdcdc;
                    display: block;
                }

                a.c24-center,
                .c24-center {
                    margin: 0 auto;
                    display: table;
                } /* GRID */
                .c24-grid-1,
                .c24-grid-2,
                .c24-grid-2-25,
                .c24-grid-3,
                .c24-grid-4,
                .c24-grid-4-5,
                .c24-grid-5,
                .c24-grid-6,
                .c24-grid-7,
                .c24-grid-8,
                .c24-grid-9,
                .c24-grid-10,
                .c24-grid-11,
                .c24-grid-12 {
                    display: inline;
                    float: left;
                    position: relative;
                    padding-left: 7px;
                    padding-right: 7px;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                }

                .push-1,
                .pull-1,
                .push-2,
                .pull-2,
                .push-3,
                .pull-3,
                .push-4,
                .pull-4,
                .push-5,
                .pull-5,
                .push-6,
                .pull-6,
                .push-7,
                .pull-7,
                .push-8,
                .pull-8,
                .push-9,
                .pull-9,
                .push-10,
                .pull-10,
                .push-11,
                .pull-11,
                .push-12,
                .pull-12 {
                    position: relative;
                }

                .alpha {
                    margin-left: 0;
                }

                .omega {
                    margin-right: 0;
                }

                /* Grid - 12 Columns */
                .c24-grid-1 {
                    width: 82.8333px;
                }

                .c24-grid-2 {
                    width: 165.6666px;
                }

                .c24-grid-2-25 {
                    width: 175px;
                }

                .c24-grid-3 {
                    width: 248.49999px;
                }

                .c24-grid-4 {
                    width: 331.3332px;
                }

                .c24-grid-4-5 {
                    width: 364px;
                }

                .c24-grid-5 {
                    width: 414.1665px;
                }

                .c24-grid-6 {
                    width: 496.9998px;
                }

                .c24-grid-7 {
                    width: 579.8331px;
                }

                .c24-grid-8 {
                    width: 662.6666px;
                }

                .c24-grid-9 {
                    width: 745.4997px;
                }

                .c24-grid-10 {
                    width: 828.3333px;
                }

                .c24-grid-11 {
                    width: 911.16663px;
                }

                .c24-grid-12 {
                    width: 994px;
                }

                .c24-grid-flex {
                    width: 100%;
                    position: relative;
                }

                .c24-grid-center {
                    margin: 0 auto;
                    float: inherit;
                    display: block;
                }

                .c24-grid-flex-content {
                    width: 994px;
                    margin: 0 auto;
                    position: relative;
                }

                /* Default grid offsets */
                .c24-grid-offset-1 {
                    margin-left: 82px;
                }

                .c24-grid-offset-2 {
                    margin-left: 165.6666px;
                }

                .c24-grid-offset-3 {
                    margin-left: 248.49999px;
                }

                .c24-grid-offset-4 {
                    margin-left: 331.3332px;
                }

                .c24-grid-offset-5 {
                    margin-left: 414.1665px;
                }

                .c24-grid-offset-6 {
                    margin-left: 496.9998px;
                }

                .c24-grid-offset-7 {
                    margin-left: 579.8331px;
                }

                .c24-grid-offset-8 {
                    margin-left: 662.6666px;
                }

                .c24-grid-offset-9 {
                    margin-left: 745.4997px;
                }

                .c24-grid-offset-10 {
                    margin-left: 828.3333px;
                }

                .c24-grid-offset-11 {
                    margin-left: 911.16663px;
                }

                /* Prefix Extra Space - 12 Columns */
                .c24-container-12 .prefix-1 {
                    padding-left: 84px;
                }

                .c24-container-12 .prefix-2 {
                    padding-left: 168px;
                }

                .c24-container-12 .prefix-3 {
                    padding-left: 252px;
                }

                .c24-container-12 .prefix-4 {
                    padding-left: 336px;
                }

                .c24-container-12 .prefix-5 {
                    padding-left: 420px;
                }

                .c24-container-12 .prefix-6 {
                    padding-left: 504px;
                }

                .c24-container-12 .prefix-7 {
                    padding-left: 588px;
                }

                .c24-container-12 .prefix-8 {
                    padding-left: 672px;
                }

                .c24-container-12 .prefix-9 {
                    padding-left: 756px;
                }

                .c24-container-12 .prefix-10 {
                    padding-left: 840px;
                }

                .c24-container-12 .prefix-11 {
                    padding-left: 924px;
                }

                /* Suffix Extra Space - 12 Columns */
                .c24-container-12 .suffix-1 {
                    padding-right: 84px;
                }

                .c24-container-12 .suffix-2 {
                    padding-right: 168px;
                }

                .c24-container-12 .suffix-3 {
                    padding-right: 252px;
                }

                .c24-container-12 .suffix-4 {
                    padding-right: 336px;
                }

                .c24-container-12 .suffix-5 {
                    padding-right: 420px;
                }

                .c24-container-12 .suffix-6 {
                    padding-right: 504px;
                }

                .c24-container-12 .suffix-7 {
                    padding-right: 588px;
                }

                .c24-container-12 .suffix-8 {
                    padding-right: 672px;
                }

                .c24-container-12 .suffix-9 {
                    padding-right: 756px;
                }

                .c24-container-12 .suffix-10 {
                    padding-right: 840px;
                }

                .c24-container-12 .suffix-11 {
                    padding-right: 924px;
                }

                /* Push Space - 12 Columns */
                .c24-container-12 .push-1 {
                    left: 84px;
                }

                .c24-container-12 .push-2 {
                    left: 168px;
                }

                .c24-container-12 .push-3 {
                    left: 252px;
                }

                .c24-container-12 .push-4 {
                    left: 336px;
                }

                .c24-container-12 .push-5 {
                    left: 420px;
                }

                .c24-container-12 .push-6 {
                    left: 504px;
                }

                .c24-container-12 .push-7 {
                    left: 588px;
                }

                .c24-container-12 .push-8 {
                    left: 672px;
                }

                .c24-container-12 .push-9 {
                    left: 756px;
                }

                .c24-container-12 .push-10 {
                    left: 840px;
                }

                .c24-container-12 .push-11 {
                    left: 924px;
                }

                /* Pull Space - 12 Columns */
                .c24-container-12 .pull-1 {
                    left: -84px;
                }

                .c24-container-12 .pull-2 {
                    left: -168px;
                }

                .c24-container-12 .pull-3 {
                    left: -252px;
                }

                .c24-container-12 .pull-4 {
                    left: -336px;
                }

                .c24-container-12 .pull-5 {
                    left: -420px;
                }

                .c24-container-12 .pull-6 {
                    left: -504px;
                }

                .c24-container-12 .pull-7 {
                    left: -588px;
                }

                .c24-container-12 .pull-8 {
                    left: -672px;
                }

                .c24-container-12 .pull-9 {
                    left: -756px;
                }

                .c24-container-12 .pull-10 {
                    left: -840px;
                }

                .c24-container-12 .pull-11 {
                    left: -924px;
                }

                /* Grid hack for EMOTION redesign */
                .c24-grid-emo {
                    padding: 0 6px;
                }

                .first .c24-grid-emo {
                    padding-left: 0;
                    padding-right: 12px;
                }

                .last .c24-grid-emo {
                    padding-right: 0;
                    padding-left: 12px;
                }

                /* reset padding for pages without fluidGrid */
                .c24-wide:not(.c24-fluid-grid) .alpha {
                    padding-left: 0;
                }
                .c24-wide:not(.c24-fluid-grid) .omega {
                    padding-right: 0;
                }

                .c24-wide.c24-fluid-grid .c24-grid-12-xs {
                    width: 994px;
                }

                .c24-wide.c24-fluid-grid .c24-grid-1 {
                    width: 70px;
                }

                .c24-wide.c24-fluid-grid .c24-grid-1 {
                    width: 8.3333%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-2 {
                    width: 16.66666667%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-3 {
                    width: 25%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-4 {
                    width: 33.33333333%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-5 {
                    width: 41.66666667%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-6 {
                    width: 50%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-7 {
                    width: 58.33333333%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-8 {
                    width: 66.66666667%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-9 {
                    width: 75%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-10 {
                    width: 83.33333333%;
                }

                .c24-wide.c24-fluid-grid .c24-grid-11 {
                    width: 91.66666667%;
                }

                .c24-grid-offset-1-half {
                    padding-left: 4.16665%;
                }

                @media (min-width: 995px) {
                    .c24-wide.c24-fluid-grid .c24-tab-group-content,
                    .c24-wide.c24-fluid-grid .c24-tab-group-flex .c24-tab-navi,
                    .c24-wide.c24-fluid-grid .c24-tab-group-navi,
                    .c24-wide.c24-fluid-grid .c24-grid-12 {
                        max-width: 1310px;
                        width: 100%;
                        min-width: 994px;
                        box-sizing: border-box;
                    }

                    /*.c24-wide.c24-fluid-grid .c24-grid-4 .c24-grid-emo {*/
                    /*margin: 0 7px;*/
                    /*overflow: hidden;*/
                    /*padding: 0;*/
                    /*}*/

                    .c24-wide.c24-fluid-grid .c24-grid-4.first .c24-grid-emo {
                        margin-left: 0;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-4.last .c24-grid-emo {
                        margin-right: 0;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-flex .c24-grid-emo {
                        /*max-width: 1280px;*/
                        /*width: 100%;*/
                        /*min-width: 994px;*/
                        /*margin: 0 auto;*/
                    }

                    /* section news */
                    .c24-wide.c24-fluid-grid .c24-tab-group-flex .c24-tab-navi-7 li {
                        width: 16.66% !important;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-6 {
                        width: 50%;
                        margin: 0;
                    }
                    /*.c24-wide.c24-fluid-grid .c24-awards-slider,*/
                    .c24-wide.c24-fluid-grid .bx-wrapper .bx-controls,
                    .c24-wide.c24-fluid-grid .c24-teaser-slider-content {
                        max-width: 1280px;
                        width: 100%;
                        min-width: 994px;
                    }

                    /* spezifikation spiegel*/
                    /*.c24-wide.c24-fluid-grid .c24-ca-websec-siegel {*/
                    /*max-width: 1280px;*/
                    /*width: calc(100% - 80px);*/
                    /*min-width: 994px;*/
                    /*}*/

                    .c24-wide.c24-fluid-grid .c24-reisefinder-box {
                        max-width: 1280px;
                        width: 100%;
                        min-width: 994px;
                        -webkit-background-size: cover;
                        background-size: cover;
                    }

                    .c24-wide.c24-fluid-grid:not(.c24-payback) .bx-wrapper .bx-controls,
                    .c24-wide.c24-fluid-grid:not(.c24-payback) .c24-teaser-slider-content {
                        max-width: 1280px;
                        width: 100%;
                        min-width: 994px;
                    }

                    .c24-wide.c24-fluid-grid .container-awards-inner {
                        max-width: 1280px;
                        width: 100%;
                        min-width: 994px;
                        margin: 0 auto;
                    }

                    /****************************************
     *
     ****************  Grid *****************
     *
     ****************************************/

                    .c24-wide.c24-fluid-grid .c24-grid-12 {
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        padding: 0 15px;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-12 .c24-grid-12 {
                        margin: 0;
                        padding: 0 7px;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-1,
                    .c24-wide.c24-fluid-grid .c24-grid-2,
                    .c24-wide.c24-fluid-grid .c24-grid-3,
                    .c24-wide.c24-fluid-grid .c24-grid-4,
                    .c24-wide.c24-fluid-grid .c24-grid-5,
                    .c24-wide.c24-fluid-grid .c24-grid-6,
                    .c24-wide.c24-fluid-grid .c24-grid-7,
                    .c24-wide.c24-fluid-grid .c24-grid-8,
                    .c24-wide.c24-fluid-grid .c24-grid-9,
                    .c24-wide.c24-fluid-grid .c24-grid-10,
                    .c24-wide.c24-fluid-grid .c24-grid-11 {
                        margin-left: 0;
                        margin-right: 0;
                        padding-left: 7px;
                        padding-right: 7px;
                        box-sizing: border-box;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-1 {
                        width: 70px;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-1 {
                        width: 8.3333%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-2 {
                        width: 16.66666667%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-3 {
                        width: 25%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-4 {
                        width: 33.33333333%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-5 {
                        width: 41.66666667%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-6 {
                        width: 50%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-7 {
                        width: 58.33333333%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-8 {
                        width: 66.66666667%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-9 {
                        width: 75%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-10 {
                        width: 83.33333333%;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-lg-11 {
                        width: 91.66666667%;
                    }

                    .c24-grid-offset-1-half {
                        padding-left: 4.16665%;
                    }
                    /*
     * Default grid offsets
     */

                    .c24-wide.c24-fluid-grid .c24-grid-offset-1 {
                        margin-left: 8.3333%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-2 {
                        margin-left: 16.66666667%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-3 {
                        margin-left: 25%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-4 {
                        margin-left: 33.33333333%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-5 {
                        margin-left: 41.66666667%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-6 {
                        margin-left: 50%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-7 {
                        margin-left: 58.33333333%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-8 {
                        margin-left: 66.66666667%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-9 {
                        margin-left: 75%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-10 {
                        margin-left: 83.3333%;
                    }
                    .c24-wide.c24-fluid-grid .c24-grid-offset-11 {
                        margin-left: 91.66666667%;
                    }

                    .c24-wide.c24-fluid-grid .c24-row {
                        margin-left: -7px;
                        margin-right: -7px;
                        box-sizing: border-box;
                        clear: both;
                    }

                    .c24-wide.c24-fluid-grid .c24-grid-flex-content {
                        min-width: 994px;
                        width: 100%;
                        max-width: 1310px;
                        box-sizing: border-box;
                        padding: 0 15px;
                    }
                }
                /* HEADER Mylists */
                .c24-mylists {
                    flex-shrink: 0;
                    width: max-content;
                    z-index: 1001;
                }

                .c24-header-inner a.c24-mylists-content {
                    display: flex;
                    margin-top: 7px;
                    padding: 16px 15px;
                    position: relative;
                    cursor: pointer;
                }

                .c24-header-inner a.c24-mylists-content:hover {
                    text-decoration: none;
                }

                #c24-mylists-text {
                    display: block;
                    font-size: 12px;
                    line-height: 14px;
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #9bd1fb;
                    cursor: default;
                }

                .c24-mylists-icon {
                    display: none;
                    position: relative;
                    cursor: pointer;
                }
                .c24-mylists-icon .c24-mylists-icon-svg,
                .c24-mylists-icon .c24-mylists-icon-svg-active {
                    display: block;
                    width: 25px;
                    height: 24px;
                    background-repeat: no-repeat;
                }
                .c24-mylists-icon .c24-mylists-icon-svg {
                    background-image: url('data:image/svg+xml;base64,PHN2ZyAgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTEwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQoJPHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTTgwLjQ2OCw3QzkzLjEwMyw3LDEwMywxNy42NzQsMTAzLDMxLjNjMCwxMy42OTctMTMuMTAzLDI2LjIyMy00OCw1OS4wODQNCgkJQzIwLjExOCw1Ny41MjksNyw0NC45MTQsNywzMS4zQzcsMTcuOTAxLDE3LjE1Miw3LDI5LjYzMSw3YzcuOTEzLDAsMTQuOTczLDQuMTk0LDE5LjM3LDExLjUwN0M1MC4yNjcsMjAuNjEyLDUyLjU0MywyMS45LDU1LDIxLjkNCgkJczQuNzMzLTEuMjg4LDUuOTk5LTMuMzkzQzY1LjMzMSwxMS4zMDIsNzIuNjEsNyw4MC40NjgsNyBNODAuNDY4LDBDNjkuNzY2LDAsNjAuMzUxLDYsNTUsMTQuOUM0OS42NDksNiw0MC41MzIsMCwyOS42MzEsMA0KCQlDMTMuMjc5LDAsMCwxNCwwLDMxLjNTMTQuNzY2LDYyLjEsNTUsMTAwYzQwLjIzNC0zNy45LDU1LTUxLjMsNTUtNjguN1M5Ny4wMTgsMCw4MC40NjgsMEw4MC40NjgsMHoiLz4NCjwvc3ZnPg==');
                }

                .c24-mylists-count {
                    position: absolute;
                    top: 9px;
                    left: 33px;
                    font-size: 11px;
                    height: 14px;
                    line-height: 14px;
                    font-weight: bold;
                    min-width: 14px;
                    text-align: center;
                    color: #ffffff;
                    background-color: #e30613;
                    -webkit-border-radius: 7px;
                    -moz-border-radius: 7px;
                    border-radius: 7px;
                    font-family: Arial, sans-serif;
                    display: none;
                }

                .c24-mylists-heart .c24-mylists-icon {
                    display: block;
                    width: 25px;
                    height: 24px;
                    float: left;
                    box-sizing: content-box;
                }

                .c24-mylists .c24-mylists-label {
                    display: inline-block;
                    margin: 5px 0 0 6px;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: 13px;
                }

                @media only screen and (max-width: 1280px) {
                    .c24-mylists .c24-mylists-label {
                        display: none;
                    }
                }

                .c24-mylists-hover {
                    display: block;
                    float: right;
                    font-size: 12px;
                    line-height: 14px;
                    font-weight: bold;
                    text-align: left;
                    padding: 5px 14px 20px 0;
                    position: relative;
                    box-sizing: border-box;
                    cursor: default;
                }

                .c24-mylists-layer {
                    visibility: hidden;
                    background: #ffffff;
                    width: 324px;
                    padding: 0;
                    box-sizing: border-box;
                    -webkit-border-radius: 8px;
                    -moz-border-radius: 8px;
                    border-radius: 8px;
                    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
                    text-align: left;
                    z-index: 1004;
                    position: absolute;
                    top: 62px;
                    right: -6px;
                    color: #333333;
                    min-height: 56px;
                }

                .c24-mylists-layer .empty {
                    padding: 20px 15px;
                    display: block;
                    font-size: 12px;
                    line-height: 16px;
                }

                .c24-mylists-layer .all {
                    padding: 0 15px;
                    color: #0563c1;
                    cursor: pointer;
                    display: none;
                }

                .c24-mylists-layer .all span {
                    display: block;
                    padding: 15px 0;
                    font-size: 12px;
                    line-height: 16px;
                    border-top: 1px solid #dcdcdc;
                    text-align: center;
                }

                .c24-mylists-layer .all:hover span {
                    text-decoration: underline;
                }

                .c24-mylists-layer .c24-mylists-headline span {
                    font-size: 14px;
                    line-height: 15px;
                    color: #333333;
                }

                .c24-mylists-layer .c24-mylists-headline {
                    margin-bottom: 5px;
                }

                .c24-mylists-layer .c24-mylists-lists {
                    padding: 15px;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #dcdcdc;
                }

                .c24-mylists-no-items {
                    display: none;
                    font-size: 12px;
                    font-weight: normal;
                    line-height: 16px;
                    padding: 20px 15px;
                }

                .c24-mylists-no-items .c24-mylists-headline {
                    margin-bottom: 10px;
                }

                .c24-mylists-home .c24-mylists-layer .c24-mylists-lists {
                    padding-bottom: 0;
                    margin-bottom: 0;
                    border-bottom: 0;
                }

                .c24-mylists .c24-mylists-item {
                    display: table;
                    border-bottom: 1px solid #dcdcdc;
                    font-size: 13px;
                    line-height: 15px;
                    position: relative;
                    padding: 10px 0;
                    width: 100%;
                }

                .c24-mylists .c24-mylists-item:hover {
                    background: #f7f7f7;
                    border-left: 15px solid #f7f7f7;
                    border-right: 15px solid #f7f7f7;
                    width: 100%;
                    left: -15px;
                }

                .c24-header-inner a.c24-mylists-item:hover,
                .c24-mylists .c24-mylists-item .c24-mylists-item-title:hover {
                    text-decoration: none;
                }

                .c24-mylists a:hover .c24-mylists-item-title {
                    text-decoration: underline;
                }

                .c24-mylists .c24-mylists-lists-items .c24-mylists-item:last-child {
                    border-bottom: none;
                }

                .c24-mylists .c24-mylists-item-product {
                    display: block;
                    margin-bottom: 5px;
                    color: #999999;
                    text-decoration: none;
                }

                .c24-mylists .c24-mylists-item-wrapper {
                    width: 100%;
                    display: table;
                    position: relative;
                }

                .c24-mylists .c24-mylists-item-img {
                    margin-right: 10px;
                    width: 35px;
                    height: 35px;
                    background-size: contain;
                    background-repeat: no-repeat;
                }

                .c24-mylists .c24-mylists-item-img {
                    max-width: 50px;
                    max-height: 70px;
                    display: table-cell;
                    vertical-align: middle;
                    margin: 0 auto;
                }

                .c24-mylists .c24-mylists-item-title-wrapper {
                    width: 290px;
                    display: table-cell;
                    vertical-align: top;
                    padding-left: 10px;
                }

                .c24-mylists .c24-mylists-item-title,
                .c24-mylists .c24-mylists-item-subtitle,
                .c24-mylists .c24-mylists-item-group {
                    display: block;
                    max-width: 265px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #333333;
                    text-decoration: none;
                }

                .c24-mylists .c24-mylists-item-title {
                    font-weight: bold;
                }

                .c24-mylists .c24-mylists-item-group {
                    margin-top: 8px;
                    line-height: 21px;
                }
                .c24-mylists .c24-mylists-item-group-count {
                    display: inline-block;
                    height: 13px;
                    line-height: 13px;
                    padding: 4px;
                    border-radius: 3px;
                    color: #ffffff;
                    background-color: #3ca7ac;
                    box-sizing: content-box;
                }

                .c24-mylists .c24-mylists-item-price-wrapper {
                    max-width: 290px;
                    text-align: right;
                    float: right;
                    margin-top: -2px;
                }

                .c24-mylists .c24-mylists-item-price-wrapper span {
                    font-size: 13px;
                    color: #333333;
                    text-decoration: none;
                    display: inline-block;
                    margin-top: 3px;
                }

                .c24-mylists .c24-mylists-item-price-wrapper span.former-payment {
                    text-decoration: line-through;
                }

                .c24-mylists .c24-mylists-item-price-wrapper .c24-mylists-item-price {
                    font-size: 16px;
                    color: #333333;
                    padding-left: 5px;
                    text-decoration: none;
                }
                .c24-mylists .c24-mylists-item-price-wrapper .former-payment {
                    padding-left: 5px;
                }
                .c24-mylists .c24-mylists-item-price-wrapper .price-prefix {
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                } /* HEADER Contact */
                .c24-contact {
                    color: #ffffff;
                    text-decoration: none;
                    flex-shrink: 0;
                    width: max-content;
                }

                .c24-contact .c24-contact-content {
                    padding: 0 15px;
                    margin-top: 7px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    text-decoration: none;
                    color: #ffffff;
                    cursor: pointer;
                    height: 56px;
                }

                .c24-contact .c24-contact-content:hover {
                    text-decoration: none;
                    color: #ffffff;
                }

                .c24-contact .c24-phone {
                    font-size: 13px;
                    line-height: 18px;
                    font-weight: normal;
                    white-space: nowrap;
                    padding: 1px 0 0 6px;
                    position: relative;
                    pointer-events: none;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .c24-contact .c24-contact-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 27px;
                    height: 24px;
                    flex-shrink: 0;
                }

                .c24-contact .c24-contact-icon-svg {
                    position: relative;
                    height: 24px;
                    width: 27px;
                    display: block;
                    background-image: url('data:image/svg+xml;base64,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');
                    background-repeat: no-repeat;
                    background-size: contain;
                }

                .c24-contact .c24-phone .c24-phone-help {
                    display: flex;
                    font-size: 13px;
                    font-weight: bold;
                    position: relative;
                }

                .c24-sticky .c24-contact .c24-phone .c24-phone-help {
                    display: none;
                }

                .c24-contact-layer {
                    visibility: hidden;
                    font-size: 12px;
                    line-height: 20px;
                    position: absolute;
                    top: 62px;
                    right: 0;
                    color: #333333;
                    text-align: left;
                    padding: 12px 15px;
                    background: #ffffff;
                    -webkit-border-radius: 8px;
                    -moz-border-radius: 8px;
                    border-radius: 8px;
                    white-space: nowrap;
                    z-index: 1002;
                    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
                }

                .c24-contact-layer-slogan {
                    font-weight: bold;
                    font-size: 14px;
                }

                .c24-contact-layer-tel {
                    text-decoration: none;
                }

                .c24-contact-layer-tel span {
                    text-decoration: none;
                    color: #0563c1;
                    font-weight: bold;
                }

                .c24-contact-layer-text {
                    margin: 15px 0 3px;
                    line-height: 17px;
                }

                .c24-contact a[href^='tel'] {
                    color: inherit;
                    text-decoration: inherit;
                    font-size: inherit;
                    font-style: inherit;
                    font-weight: inherit;
                }

                .c24-contact .c24-contact-info {
                    display: inline-block;
                    float: left;
                    margin: 2px 0 0 5px;
                    font-size: 10px;
                    line-height: 10px;
                    font-weight: bold;
                    text-align: center;
                    width: 13px;
                    background: #ffffff;
                    color: #0563c1;
                    border-radius: 7px;
                    padding: 1px 0 2px;
                    cursor: pointer;
                }

                .c24-contact-hover {
                    background-color: #ffffff;
                    color: #333333;
                    padding: 11px;
                    border: 1px solid #dcdcdc;
                    height: auto;
                    width: 324px;
                    position: absolute;
                    top: 51px;
                    left: 0;
                    z-index: 10001;
                    display: none;
                    font-size: 10px;
                    line-height: 14px;
                }

                .c24-contact-hover.c24-contact-hover-product {
                    width: auto;
                    white-space: nowrap;
                }

                .c24-contact-hover table {
                    padding-bottom: 5px;
                }

                .c24-contact-hover table:last-child {
                    padding-bottom: 0;
                }

                .c24-contact-hover .c24-time-product {
                    width: 160px;
                    font-weight: bold;
                }

                .c24-contact-hover .c24-hotline-headline {
                    border-bottom: 1px solid #dcdcdc;
                    padding-bottom: 6px;
                    margin-bottom: 8px;
                    font-size: 13px;
                    display: block;
                    width: 100%;
                }

                .c24-contact-hover .c24-hotline-hours {
                    display: block;
                    font-size: 12px;
                    line-height: 15px;
                }

                .c24-payback .c24-contact {
                    margin-top: 0;
                    display: flex;
                    align-items: center;
                }

                .c24-payback .c24-contact .c24-contact-content {
                    align-items: center;
                }

                .c24-payback .c24-contact-icon {
                    padding-top: 0;
                    padding-bottom: 0;
                }

                .c24-payback .c24-phone {
                    margin-top: 0;
                } /* HEADER Customer */
                .c24-customer {
                    flex-shrink: 0;
                    width: max-content;
                }
                .c24-customer .c24-customer-hover-wrapper {
                    display: inline-block;
                    color: #ffffff;
                    position: relative;
                    cursor: pointer;
                    margin-top: 7px;
                    padding: 16px 0 16px 15px;
                }
                .c24-customer .c24-customer-hover-wrapper:hover {
                    color: #ffffff;
                    text-decoration: none;
                }

                .c24-customer-icon {
                    width: 24px;
                    height: 24px;
                    display: block;
                    float: left;
                }
                .c24-customer-icon.c24-customer-icon-lo {
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgICA8cGF0aCBkPSJNMTEsMEM0LjkyNCwwLDAsNC45MjQsMCwxMXM0LjkyNCwxMSwxMSwxMSwxMS00LjkyNCwxMS0xMVMxNy4wNzYsMCwxMSwwWm0wLDIwLjYyNWMtMi4wMywwLTMuOTEyLS42MzUtNS40NjYtMS43MTIsLjE3Ni0yLjExNywxLjkzNC0zLjc4OCw0LjA5MS0zLjc4OGgyLjc1YzIuMTU5LDAsMy45MTYsMS42NzMsNC4wOTEsMy43ODgtMS41NTYsMS4wNzYtMy40MzgsMS43MTItNS40NjYsMS43MTJabTYuNjktMi43MmMtLjYwNi0yLjM4LTIuNzUtNC4xNTUtNS4zMTUtNC4xNTVoLTIuNzVjLTIuNTY3LDAtNC43MDksMS43NzUtNS4zMTUsNC4xNTYtMS44MDYtMS43ODgtMi45MzUtNC4xOTktMi45MzUtNi45MDZDMS4zNzUsNS42OTMsNS42OTMsMS4zNzUsMTEsMS4zNzVzOS42MjUsNC4zMTgsOS42MjUsOS42MjVjMCwyLjcwNy0xLjEzLDUuMTE4LTIuOTM1LDYuOTA1Wk0xMSw1LjVjLTEuODk5LDAtMy40MzcsMS41MzgtMy40MzcsMy40MzhzMS41MzgsMy40MzgsMy40MzcsMy40MzgsMy40MzctMS41MzksMy40MzctMy40MzgtMS41MzgtMy40MzgtMy40MzctMy40MzhabTAsNS41Yy0xLjEzOSwwLTIuMDYyLS45MjQtMi4wNjItMi4wNjJzLjkyNC0yLjA2MiwyLjA2Mi0yLjA2MiwyLjA2MiwuOTI1LDIuMDYyLDIuMDYyLS45MjQsMi4wNjItMi4wNjIsMi4wNjJaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPg==');
                    background-repeat: no-repeat;
                }
                .c24-customer-icon.c24-customer-icon-li {
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgPHBhdGggZD0iTTExLDBDNC45MjQsMCwwLDQuOTI0LDAsMTFzNC45MjQsMTEsMTEsMTEsMTEtNC45MjQsMTEtMTFTMTcuMDc2LDAsMTEsMFptNi42OSwxNy45MDVjLS42MDYtMi4zOC0yLjc1LTQuMTU1LTUuMzE1LTQuMTU1aC0yLjc1Yy0yLjU2NSwwLTQuNzA5LDEuNzc1LTUuMzE1LDQuMTU1LTEuODA1LTEuNzg3LTIuOTM1LTQuMTk4LTIuOTM1LTYuOTA1QzEuMzc1LDUuNjkzLDUuNjkzLDEuMzc1LDExLDEuMzc1czkuNjI1LDQuMzE4LDkuNjI1LDkuNjI1YzAsMi43MDctMS4xMyw1LjExOC0yLjkzNSw2LjkwNVoiIGZpbGw9IiNmZmYiLz4KICA8Y2lyY2xlIGN4PSIxMSIgY3k9IjguOTM3IiByPSIzLjQzOCIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4=');
                    background-repeat: no-repeat;
                }

                .c24-customer-hover {
                    display: block;
                    float: left;
                    max-width: 120px;
                    padding-top: 4px;
                    font-size: 13px;
                    line-height: 19px;
                    font-weight: bold;
                    position: relative;
                    box-sizing: border-box;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    margin-left: 6px;
                }

                .c24-customer-layer {
                    background: #ffffff;
                    width: 240px;
                    padding: 15px 15px 3px;
                    box-sizing: border-box;
                    -webkit-border-radius: 8px;
                    -moz-border-radius: 8px;
                    border-radius: 8px;
                    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
                    text-align: left;
                    z-index: 1004;
                    position: absolute;
                    top: 62px;
                    right: 0;
                    font-size: 12px;
                    visibility: hidden;
                }

                .c24-customer-user .c24-customer-layer {
                    padding: 10px 15px 3px;
                }

                .c24-customer-layer .c24-button {
                    display: block;
                    font-size: 14px;
                    line-height: 16px;
                    font-weight: bold;
                    color: #ffffff;
                    width: 100%;
                    padding: 8px 0;
                    text-align: center;
                    text-decoration: none;
                    margin-bottom: 10px;
                }
                .c24-customer-layer .c24-customer-salutation-text {
                    padding-bottom: 6px;
                    border-bottom: 1px solid #dcdcdc;
                    margin-bottom: 10px;
                }
                .c24-customer-layer .c24-customer-salutation-text span {
                    display: inline;
                    font-size: 13px;
                    line-height: 16px;
                    color: #333333;
                }
                .c24-customer-layer .c24-customer-salutation-text a {
                    display: inline;
                    font-size: 13px;
                    line-height: 16px;
                    text-decoration: none;
                }
                .c24-customer-layer .c24-customer-salutation-text a:hover {
                    text-decoration: underline;
                }
                .c24-customer-layer .c24-customer-options {
                    display: block;
                    padding: 0 0 10px;
                    margin: 0;
                }
                .c24-customer-layer .c24-customer-options li,
                .c24-customer-layer .c24-customer-center li {
                    list-style: none;
                    font-size: 13px;
                    line-height: 22px;
                    width: 100%;
                }
                .c24-customer-layer .c24-customer-options li a {
                    display: block;
                    color: #333333;
                }
                .c24-customer-layer .c24-customer-center {
                    display: block;
                    margin: 0;
                    padding: 10px 0 10px;
                    border-top: 1px solid #dcdcdc;
                }
                .c24-customer-layer .c24-customer-center li.c24-customer-center-km {
                    border-bottom: 1px solid #dcdcdc;
                    padding-bottom: 9px;
                }

                .c24-customer-layer .c24-customer-center li:last-child {
                    margin-bottom: 0;
                }
                .c24-customer-layer .c24-customer-center li a,
                .c24-customer-layer .c24-customer-check a {
                    display: block;
                    text-decoration: none;
                    color: #333333;
                }
                .c24-customer-layer .c24-customer-check a:hover {
                    text-decoration: underline;
                }
                .c24-customer-layer .c24-customer-center li a:hover span:first-child {
                    text-decoration: underline;
                }
                .c24-customer-layer #c24-meinkonto-abmelden {
                    margin-top: 8px;
                    margin-bottom: 0;
                }

                .c24-customer-check {
                    border-top: 1px solid #dcdcdc;
                    padding: 8px 0 5px;
                    margin: 0;
                    line-height: 22px;
                }

                .c24-customer-check .c24-customer-check-q {
                    color: #333333;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .c24-customer-trigger {
                    display: none;
                    position: relative;
                }

                .c24-customer-trigger .c24-customer-layer {
                    padding: 17px 16px;
                    width: 232px;
                    box-sizing: border-box;
                }

                .c24-customer-trigger .c24-customer-trigger-close {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    width: 14px;
                    height: 14px;
                    cursor: pointer;
                }

                .c24-customer-trigger .c24-customer-trigger-text {
                    color: #333333;
                    margin: 0 0 7px;
                    padding: 0;
                    line-height: 18px;
                }

                .c24-customer-trigger .c24-customer-salutation-text {
                    border: 0;
                    margin: 0;
                    padding: 0;
                }

                .c24-customer-trigger .c24-button {
                    margin-bottom: 7px;
                }
                /* HEADER Notification */
                .c24-notification {
                    flex-shrink: 0;
                    width: max-content;
                }

                .c24-notification-icon {
                    display: block;
                    width: 24px;
                    height: 24px;
                    position: relative;
                    margin-top: 7px;
                    padding: 16px 15px;
                    cursor: pointer;
                    box-sizing: content-box;
                }
                .c24-notification-icon .c24-notification-icon-svg,
                .c24-notification-icon .c24-notification-icon-svg-active {
                    display: block;
                    width: 24px;
                    height: 24px;
                    background-repeat: no-repeat;
                }
                .c24-notification-icon .c24-notification-icon-svg {
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTggMjEyIj4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTIxLjIsMTgzLjVjLTEuOC0uNi0zLjgtLjUtNS42LjMtMS44LjgtMy4xLDIuMy0zLjcsNC4xLTIsNS41LTcuMiw5LjItMTMuMSw5LjJzLTExLjEtMy43LTEzLjEtOS4yYy0xLjMtMy44LTUuNS01LjgtOS4zLTQuNS0xLjguNi0zLjMsMS45LTQuMSwzLjctLjksMS44LTEsMy44LS4zLDUuNiw0LDExLjQsMTQuOCwxOSwyNi44LDE5czIyLjgtNy42LDI2LjgtMTljMS4zLTMuOC0uNy04LTQuNS05LjNoMGwuMS4xaDBaIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE5MiwxMzUuOGwtMS4yLTEuMmMtMTMuNy0xMy43LTIxLjItMzEuOS0yMS4yLTUxLjJ2LTEyLjhjMC0xNy43LTYuNS0zNC42LTE4LjQtNDcuNi0uNDg3LS41MzctLjk4Mi0xLjA2Ny0xLjQ4NS0xLjU4N0MxMzYuNDg1LDcuNjk0LDExOC4wMDQuMyw5OC45NDUuM2gtLjM4OWMtMTMuMDg3LDAtMjYuMDMxLDMuMzk5LTM3LjEzNywxMC4zMjMtNS40MzksMy4zOTEtMTAuNDMxLDcuNTM5LTE0LjgxOCwxMi4zNzctMTEuOSwxMy0xOC40LDMwLTE4LjQsNDcuNnYxMi44YzAsMTktNy43LDM3LjctMjEuMiw1MS4xbC0xLjIsMS4yQzIuMSwxMzkuNCwwLDE0NC41LDAsMTQ5LjcsMCwxNjAuNiw4LjksMTY5LjUsMTkuOCwxNjkuNWgxNTguMzE4YzEwLjk1OSwwLDE5Ljg5OS04Ljg3MSwxOS44ODItMTkuODMxLS4wMTctMTAuNzY1LTIuMTE1LTEwLjE4NC01LjgtMTMuODY5aC0uMlpNOTkuNCwxNC40YzMwLjcuMyw1NS41LDI1LjQsNTUuNSw1Ni4xdjEyLjhjMCwyMi45LDkuMyw0NS4zLDI1LjUsNjEuNWwxLjIsMS4yYy44MzIuODMyLDEuMzE4LDEuODcxLDEuNDU4LDMuMDAzLjM5OSwzLjIyNy0yLjIzNyw1Ljg5Ny01LjQ4OSw1Ljg5N0gxOS43Yy0yLjgsMC01LjItMi4zLTUuMi01LjJzLjUtMi43LDEuNS0zLjdsMS4yLTEuMmMxNi40LTE2LjQsMjUuNS0zOC4yLDI1LjUtNjEuNXYtMTIuOGMwLTMxLDI1LjItNTYuMSw1Ni4xLTU2LjEsMCwwLC42LDAsLjYsMFoiLz4KPC9zdmc+');
                }

                .c24-notification-count {
                    position: absolute;
                    top: 9px;
                    right: 12px;
                    font-size: 11px;
                    height: 14px;
                    line-height: 14px;
                    font-weight: bold;
                    width: 14px;
                    text-align: center;
                    color: #ffffff;
                    background-color: #e30613;
                    -webkit-border-radius: 7px;
                    -moz-border-radius: 7px;
                    border-radius: 7px;
                    font-family: Arial, sans-serif;
                    display: none;
                }

                .c24-notification-layer-hover {
                    visibility: hidden;
                    position: absolute;
                    top: 62px;
                    right: -6px;
                    width: 338px;
                    z-index: 1003;
                }

                .c24-notification-layer {
                    background: #ffffff;
                    -webkit-border-radius: 8px;
                    -moz-border-radius: 8px;
                    border-radius: 8px;
                    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
                    z-index: 1003;
                    overflow: hidden;
                }

                .c24-notification-layer .content {
                    font-size: 12px;
                    line-height: 16px;
                }

                .c24-notification-layer .content.list-content {
                    padding: 15px 15px 0;
                }

                .c24-notification-layer .content .news-feed-headline {
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 10px;
                }

                .c24-notification-layer .content .message {
                    position: relative;
                    cursor: pointer;
                    display: flex;
                    padding-top: 10px;
                }

                .c24-notification-layer .content .message {
                    padding-bottom: 10px;
                }

                .c24-notification-layer .content .message:nth-child(1) {
                    margin-top: -5px;
                }

                .c24-notification-layer .content .message:not(:last-child) {
                    border-bottom: 1px solid #dcdcdc;
                }

                .c24-notification-layer .content .message:hover {
                    background: #f7f7f7;
                    border-left: 15px solid #f7f7f7;
                    border-right: 15px solid #f7f7f7;
                    width: 100%;
                    left: -15px;
                }

                .c24-notification-layer .content .message .content-wrapper {
                    max-width: 225px;
                    margin-right: 4px;
                }

                .c24-notification-layer .content .message .subline {
                    font-size: 12px;
                    color: #999;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .c24-notification-layer .content .message .news-image {
                    width: 35px;
                    height: 35px;
                    background-size: contain;
                    background-repeat: no-repeat;
                    flex-shrink: 0;
                    margin-right: 10px;
                }

                .c24-notification-layer .content .message .news-default-image {
                    background-image: url('data:image/svg+xml;base64,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');
                }

                .c24-header-inner .c24-notification-layer a:hover.message.unread {
                    text-decoration: none;
                }

                .c24-notification-layer .content .message .date {
                    font-size: 10px;
                    color: #999999;
                    top: 10px;
                    right: 13px;
                }

                .c24-notification-layer .content .message .title {
                    color: #333333;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    height: 17px;
                    margin-bottom: 2px;
                    font-size: 14px;
                }

                .c24-notification-layer .content .message .text {
                    color: #333;
                    overflow: hidden;
                    height: 34px;
                    position: relative;
                    line-height: 16px;
                    font-size: 14px;
                }

                .c24-notification-layer .content .message .product-name {
                    color: #666;
                    position: relative;
                    line-height: 16px;
                    font-size: 12px;
                    margin-top: 4px;
                }

                .c24-notification-layer .content .empty {
                    color: #333333;
                    text-align: left;
                    font-size: 12px;
                    line-height: 16px;
                    padding: 20px 15px;
                }

                .c24-mylists-layer .loader {
                    text-align: center;
                    padding: 15px 0;
                    -moz-border-radius: 5px;
                    -webkit-border-radius: 5px;
                    border-radius: 5px;
                    background: #efeff4
                        linear-gradient(
                            120deg,
                            rgba(221, 221, 221, 0) 30%,
                            rgba(221, 221, 221, 0.5) 50%,
                            rgba(221, 221, 221, 0) 70%
                        );
                    background-size: 200% 100%;
                    background-position-x: 180%;
                    animation: 1s c24wfloadingscreen ease-in-out infinite;
                }

                .c24-notification-layer .loader .loading-news-item-image,
                .c24-notification-layer .loader .loading-news-item-line {
                    background: #efeff4
                        linear-gradient(
                            120deg,
                            rgba(221, 221, 221, 0) 30%,
                            rgba(221, 221, 221, 0.5) 50%,
                            rgba(221, 221, 221, 0) 70%
                        );
                    background-size: 200% 100%;
                    background-position-x: 180%;
                    animation: 1s c24wfloadingscreen ease-in-out infinite;
                }

                .c24-notification-layer .content .loader .loading-news-item {
                    display: flex;
                    gap: 10px;
                    padding-bottom: 10px;
                }

                .c24-notification-layer .content .loader .loading-news-item:not(:last-child) {
                    border-bottom: 1px solid #dcdcdc;
                }

                .c24-notification-layer .content .loader .loading-news-item:not(:first-child) {
                    padding-top: 10px;
                }

                .c24-notification-layer .content .loader .loading-news-item-image {
                    width: 35px;
                    height: 35px;
                    border-radius: 10px;
                    flex-shrink: 0;
                }

                .c24-notification-layer .content .loader .loading-news-item-text-container {
                    width: 100%;
                }

                .c24-notification-layer .content .loader .loading-news-item-line {
                    border-radius: 5px;
                    height: 12px;
                    width: 100%;
                    margin-top: 4px;
                }

                .c24-notification-layer .content .loader .loading-news-item-first-line {
                    margin-bottom: 8px;
                }

                .c24-notification-layer .content .loader .loading-news-item-line:last-child {
                    margin-top: 12px;
                    width: 175px;
                }

                .c24-notification-layer .content .loader .loading-news-item-first-line .loading-news-item-line {
                    margin-top: 0;
                }

                .c24-notification-layer
                    .content
                    .loader
                    .loading-news-item-first-line
                    .loading-news-item-line:first-child {
                    width: 200px;
                    margin-right: 8px;
                    display: inline-block;
                }
                .c24-notification-layer
                    .content
                    .loader
                    .loading-news-item-first-line
                    .loading-news-item-line:nth-child(2) {
                    width: 55px;
                    display: inline-block;
                }

                @keyframes c24wfloadingscreen {
                    to {
                        background-position-x: -20%;
                    }
                }

                #c24-lastseen .loader {
                    margin: 457px auto;
                    width: 0;
                }

                #c24-lastseen .spinner .bar {
                    top: 180px;
                }

                .c24-notification-layer .content .message .text .more {
                    position: absolute;
                    bottom: 2px;
                    right: 0;
                    background: #fff;
                }

                .c24-notification-layer .content .message .text .more:before {
                    padding-left: 3px;
                }

                .c24-notification-layer .content .message .text .more.dot:before {
                    content: '... ';
                }

                .c24-notification-layer .content .message:hover .text .more {
                    background: #f9f9f9;
                }

                .c24-notification-layer .content .message:hover .text .more a {
                    text-decoration: underline;
                }

                .c24-notification-layer .all {
                    text-align: center;
                    padding: 15px 0;
                    border-top: 1px solid #dcdcdc;
                    color: #0563c1;
                    cursor: pointer;
                    display: none;
                    margin: 0 15px;
                    font-size: 12px;
                }

                @keyframes c24-notification-loader-0 {
                    0% {
                        opacity: 0.25007500000000005;
                    }
                    0.01% {
                        opacity: 0.25;
                    }
                    0.02% {
                        opacity: 1;
                    }
                    0.010000000000005116% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.25007500000000005;
                    }
                }

                @keyframes c24-notification-loader-1 {
                    0% {
                        opacity: 0.3250750000000001;
                    }
                    10.01% {
                        opacity: 0.25;
                    }
                    10.02% {
                        opacity: 1;
                    }
                    10.010000000000005% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.3250750000000001;
                    }
                }

                @keyframes c24-notification-loader-2 {
                    0% {
                        opacity: 0.40007500000000007;
                    }
                    20.01% {
                        opacity: 0.25;
                    }
                    20.020000000000003% {
                        opacity: 1;
                    }
                    20.010000000000005% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.40007500000000007;
                    }
                }

                @keyframes c24-notification-loader-3 {
                    0% {
                        opacity: 0.475075;
                    }
                    30.01% {
                        opacity: 0.25;
                    }
                    30.020000000000003% {
                        opacity: 1;
                    }
                    30.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.475075;
                    }
                }

                @keyframes c24-notification-loader-4 {
                    0% {
                        opacity: 0.550075;
                    }
                    40.01% {
                        opacity: 0.25;
                    }
                    40.019999999999996% {
                        opacity: 1;
                    }
                    40.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.550075;
                    }
                }

                @keyframes c24-notification-loader-5 {
                    0% {
                        opacity: 0.625075;
                    }
                    50.01% {
                        opacity: 0.25;
                    }
                    50.019999999999996% {
                        opacity: 1;
                    }
                    50.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.625075;
                    }
                }

                @keyframes c24-notification-loader-6 {
                    0% {
                        opacity: 0.700075;
                    }
                    60.01% {
                        opacity: 0.25;
                    }
                    60.019999999999996% {
                        opacity: 1;
                    }
                    60.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.700075;
                    }
                }

                @keyframes c24-notification-loader-7 {
                    0% {
                        opacity: 0.7750750000000001;
                    }
                    70.01% {
                        opacity: 0.25;
                    }
                    70.02000000000001% {
                        opacity: 1;
                    }
                    70.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.7750750000000001;
                    }
                }

                @keyframes c24-notification-loader-8 {
                    0% {
                        opacity: 0.850075;
                    }
                    80.01% {
                        opacity: 0.25;
                    }
                    80.02000000000001% {
                        opacity: 1;
                    }
                    80.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.850075;
                    }
                }

                @keyframes c24-notification-loader-9 {
                    0% {
                        opacity: 0.9250750000000001;
                    }
                    90.01% {
                        opacity: 0.25;
                    }
                    90.02000000000001% {
                        opacity: 1;
                    }
                    90.00999999999999% {
                        opacity: 0.25;
                    }
                    100% {
                        opacity: 0.9250750000000001;
                    }
                } /* HEADER Search */
                .c24-search * {
                    box-sizing: border-box;
                }
                .c24-search {
                    flex-grow: 1;
                    min-width: 100px;
                    margin-top: 16px;
                    padding: 0 15px;
                }
                .c24-search-slim .c24-search {
                    display: none;
                }

                header .c24-search-content fieldset {
                    position: relative;
                }

                .c24-search .c24-search-corner {
                    display: none;
                    z-index: 5004;
                }

                .c24-search .c24-search-content {
                    display: block;
                }

                .c24-search input.c24-search-input {
                    width: 100%;
                    height: 40px;
                    padding: 0 54px 0 16px;
                    font-family: Verdana, Arial, Helvetica, sans-serif;
                    font-size: 15px;
                    line-height: 18px;
                    color: #333333;
                    border: none;
                    box-sizing: border-box;
                    -webkit-border-radius: 20px;
                    -moz-border-radius: 20px;
                    border-radius: 20px;
                    position: relative;
                    z-index: 10014;
                    -webkit-appearance: none;
                }

                .c24-search .c24-search-input::-ms-clear {
                    display: none;
                }

                .c24-search .open input.c24-search-input {
                    -webkit-border-radius: 20px 20px 0 0;
                    -moz-border-radius: 20px 20px 0 0;
                    border-radius: 20px 20px 0 0;
                }

                .c24-search input.c24-search-input:focus,
                .c24-search .open input.c24-search-input {
                    border: 2px solid #ffbb1c;
                    color: #333333;
                    padding: 0 54px 0 14px;
                }

                .c24-search .open input.c24-search-input {
                    border-bottom: none;
                    padding-bottom: 2px;
                }

                .c24-search input.c24-search-input::placeholder {
                    color: #999;
                    opacity: 1;
                }

                .c24-search input.c24-search-input::-webkit-input-placeholder {
                    color: #999;
                    opacity: 1;
                }

                .c24-search input.c24-search-input::-moz-placeholder {
                    color: #999;
                    opacity: 1;
                }

                .c24-search input.c24-search-input:-ms-input-placeholder {
                    color: #999;
                }

                .c24-search input.c24-search-input:-moz-placeholder {
                    color: #999;
                    opacity: 1;
                }

                .c24-search .c24-search-button {
                    width: 40px;
                    height: 40px;
                    padding: 10px 11px 10px 12px;
                    position: absolute;
                    top: 0;
                    right: 5px;
                    cursor: pointer;
                    z-index: 10015;
                }

                .c24-search .open .c24-search-button {
                    -webkit-border-radius: 0 20px 0 0;
                    -moz-border-radius: 0 20px 0 0;
                    border-radius: 0 20px 0 0;
                }

                .c24-search-icon {
                    display: none;
                    flex-shrink: 0;
                    width: max-content;
                    position: relative;
                    margin-top: 15px;
                    padding: 8px 15px;
                    cursor: pointer;
                }

                .c24-search-icon-content {
                    display: block;
                    width: 21px;
                    height: 24px;
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgODcuMSAxMDAiPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik02NC44LDE0LjFDNTIuNi0xLjcsMjkuOS00LjYsMTQuMSw3LjVTLTQuNiw0Mi40LDcuNSw1OC4yYzExLDE0LjIsMzAuMywxNy45LDQ1LjYsOS45TDc3LDk5DQoJYzAuOSwxLjIsMi42LDEuNCwzLjYsMC41bDUuNS00LjJjMS4yLTAuOSwxLjQtMi42LDAuNS0zLjZMNjIuOCw2MC44Qzc0LjUsNDgsNzUuOCwyOC4yLDY0LjgsMTQuMXogTTUyLjksNTcuOA0KCWMtMTEuOSw5LjItMjkuMSw3LTM4LjMtNWMtOS4zLTExLjktNy0yOS4xLDUtMzguM2MxMS45LTkuMywyOS4xLTcsMzguMyw1QzY3LjEsMzEuNCw2NC44LDQ4LjUsNTIuOSw1Ny44eiIvPg0KPC9zdmc+');
                    background-repeat: no-repeat;
                    background-size: 21px;
                    background-position: center;
                }

                .c24-search-slim .c24-search-icon {
                    display: block;
                    flex-shrink: initial;
                    flex-grow: 0;
                    padding: 17px 15px;
                    margin-top: 6px;
                }

                .c24-search-slim .c24-search-icon-content {
                    float: right;
                }

                .c24-search-slim .c24-search-icon.open {
                    display: none;
                }

                .c24-search-slim .c24-search-content {
                    display: none;
                }

                .open .hits-search-input {
                    border-bottom-left-radius: 0 !important;
                }

                #c24-search-header::-webkit-input-placeholder {
                    /* Chrome */
                    color: #999999;
                    background-color: #ffffff;
                }

                #c24-search-header:-ms-input-placeholder {
                    /* IE 10+ */
                    color: #999999;
                    background-color: #ffffff;
                }

                #c24-search-header::-moz-placeholder {
                    /* Firefox 19+ */
                    color: #999999;
                    background-color: initial;
                    opacity: 1;
                }

                #c24-search-header:-moz-placeholder {
                    /* Firefox 4 - 18 */
                    color: #999999;
                    background-color: initial;
                    opacity: 1;
                }

                .hits-search-element {
                    border-radius: 0;
                }
                .hits-layer {
                    z-index: 10012;
                    background-color: #1d1d1b;
                    opacity: 0;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    cursor: pointer;
                }

                .hits-suggest {
                    font-family: Verdana, Arial, sans-serif;
                    background: #fff;
                    position: absolute;
                    z-index: 10013;
                    width: 100%;
                    box-sizing: border-box;
                    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
                    border-radius: 0 0 20px 20px;
                    overflow: hidden;
                    border: 2px solid #feb018;
                    border-top: none;
                }

                .hits-suggest a {
                    color: #333333;
                    display: block;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .hits-suggest a:hover,
                .hits-suggest a:focus,
                .hits-suggest a:active {
                    text-decoration: none;
                }

                .c24-header-inner .hits-suggest a:hover {
                    color: #333333;
                }

                .hits-suggest ul {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    border-top: 1px solid #dcdcdc;
                }

                .hits-suggest ul li.hits-suggest-item {
                    font-size: 15px;
                    line-height: 28px;
                    margin: 0;
                    padding: 5px 14px;
                    border-radius: 0;
                    list-style-position: inside;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .hits-suggest ul li.hits-suggest-item-hover,
                .hits-suggest ul li.hits-suggest-item-active {
                    background: #eeeeee;
                    cursor: pointer;
                }

                .hits-suggest hr {
                    margin: 0;
                    line-height: 1px;
                    border: none;
                    border-top: 1px solid #eeeeee;
                }

                .hits-suggest .hits-suggest-directlink {
                    color: #333333;
                    font-weight: normal;
                }

                .hits-suggest-directlink-subtitle {
                    color: #0563c1;
                }

                .hits-suggest .hits-suggest-category {
                    color: #999999;
                    font-size: 12px;
                }

                .c24-search-content form fieldset {
                    position: relative;
                }

                .c24-search .hits-search-button {
                    background: #ffbb1c;
                    width: 26px;
                    height: 26px;
                    padding: 7px 5px 7px 8px;
                    float: left;
                    position: absolute;
                    top: 0 !important;
                    right: 0 !important;
                    left: 78%;
                    border-left: 0 !important;
                    cursor: pointer;
                    border-radius: 0 4px 4px 0;
                }

                .c24-search .open .hits-search-button {
                    border-bottom-right-radius: 0 !important;
                }

                .hits-suggest ul li.hits-suggest-item.hits-suggest-cat {
                    line-height: 16px;
                }

                .hits-search-input {
                    width: 78% !important;
                    height: 40px;
                    padding: 0 34px 0 10px;
                    font-family: Verdana, Arial, Helvetica, sans-serif;
                    font-size: 14px;
                    line-height: 18px;
                    color: #333333;
                    border: 1px solid #dcdcdc !important;
                    box-sizing: border-box;
                    -webkit-border-radius: 0 !important;
                    -moz-border-radius: 0 !important;
                    border-radius: 4px 0 0 4px !important;
                    -webkit-box-shadow: none !important;
                    -moz-box-shadow: none !important;
                    box-shadow: none !important;
                    background: #ffffff;
                }

                .open .hits-search-input {
                    border-bottom-left-radius: 0 !important;
                }

                #c24-search-header::-webkit-input-placeholder {
                    /* Chrome */
                    color: #999999;
                    background-color: #ffffff;
                }
                #c24-search-header:-ms-input-placeholder {
                    /* IE 10+ */
                    color: #999999;
                    background-color: #ffffff;
                }
                #c24-search-header::-moz-placeholder {
                    /* Firefox 19+ */
                    color: #999999;
                    background-color: initial;
                    opacity: 1;
                }
                #c24-search-header:-moz-placeholder {
                    /* Firefox 4 - 18 */
                    color: #999999;
                    background-color: initial;
                    opacity: 1;
                }

                .hits-suggest li {
                    padding-left: 10px;
                    padding-right: 10px;
                }

                .hits-takeover-arrow {
                    height: 11px;
                    width: 11px;
                    background: url('https://search.check24.de/suche/img/takeover-arrow.svg') no-repeat center center;
                    -webkit-background-size: 11px 11px;
                    background-size: 11px 11px;
                    position: absolute;
                    right: 0;
                    float: right;
                    display: block;
                    padding: 12px;
                    margin: -8px 0;
                }

                .hits-suggest-phraselink {
                    float: left;
                }

                .search-grey-out-overlay {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: black;
                    opacity: 0.6;
                    -webkit-opacity: 0.6;
                    content: '';
                    animation: grey-out-fade-in 0.2s;
                    z-index: 1000;
                }

                @keyframes grey-out-fade-in {
                    0% {
                        opacity: 0;
                    }
                    100% {
                        opacity: 60%;
                    }
                } /* HEADER sticky */
                .c24-sticky #c24-header {
                    top: -45px;
                    z-index: 20002;
                    min-height: inherit;
                    position: relative;
                    -moz-transition-property: top;
                    -o-transition-property: top;
                    -webkit-transition-property: top;
                    transition-property: top;
                    -moz-transition-duration: 0.3s;
                    -o-transition-duration: 0.3s;
                    -webkit-transition-duration: 0.3s;
                    transition-duration: 0.3s;
                }
                .c24-sticky #c24-header.c24-sticky-animate {
                    top: 0;
                    position: fixed;
                }

                .c24-sticky .c24-logo {
                    width: 130px;
                    height: 32px;
                    top: 12px;
                    left: 0;
                    z-index: 1001;
                }

                .c24-sticky .c24-logo svg {
                    width: 100%;
                }

                .c24-sticky #c24-header-top {
                    height: 48px;
                }

                .c24-sticky #c24-header-bottom {
                    height: 0;
                    border: 0;
                    width: 190px;
                }

                .c24-sticky:not(.c24-responsive) #c24-header-bottom {
                    padding: 0 15px;
                }

                .c24-sticky #c24-mainnav {
                    top: 51px;
                }

                .c24-sticky .c24-nav-button-wrapper {
                    width: inherit;
                }

                .c24-wide.c24-sticky .c24-search {
                    padding-top: 4px;
                }

                .c24-sticky .c24-search {
                    left: 255px;
                }

                .c24-sticky .c24-search-include .c24-search {
                    display: block;
                }

                .c24-sticky .c24-search-content {
                    display: none;
                }

                .c24-sticky .c24-search-icon {
                    width: 20px;
                    position: relative;
                    float: right;
                    top: inherit;
                    left: inherit;
                    display: inline-block;
                    margin-top: 12px;
                    margin-left: 22px;
                }

                .c24-sticky #c24-customer-salutation,
                .c24-sticky .c24-customer-hover {
                    display: none;
                }

                .c24-sticky .c24-customer {
                    padding: 0;
                }

                .c24-sticky .c24-customer-layer {
                    top: 48px;
                }

                .c24-sticky .c24-notification {
                    margin-top: 13px;
                }

                .c24-sticky .c24-notification-icon {
                    height: 32px;
                    padding-bottom: 4px;
                }

                .c24-sticky .c24-notification-layer-hover {
                    top: 48px;
                }

                .c24-sticky .c24-notifications-include .c24-notification {
                    display: block;
                }

                .c24-sticky .c24-mylists {
                    margin-top: 10px;
                }

                .c24-sticky .c24-mylists .c24-mylists-label {
                    display: none;
                }

                .c24-sticky .c24-mylists-icon {
                    display: block;
                    margin: 3px auto 0;
                    height: 35px;
                    width: 24px;
                    position: relative;
                }

                .c24-sticky .c24-mylists-icon.active .c24-mylists-icon-svg {
                    display: none;
                }

                .c24-sticky .c24-mylists-icon.active .c24-mylists-icon-svg-active {
                    display: block;
                }

                .c24-sticky .c24-mylists-icon .c24-svg-heart {
                    display: none;
                }

                .c24-sticky .c24-mylists-heart .c24-mylists-icon .c24-svg-heart {
                    display: block;
                }

                .c24-sticky .c24-mylists-layer {
                    top: 48px;
                }

                .c24-sticky .c24-contact-layer {
                    top: 48px;
                }

                .c24-sticky .c24-mylists-heart .c24-mylists-icon {
                    padding-bottom: 0;
                }

                .c24-sticky .c24-nonav .c24-logo {
                    left: 10px;
                }

                .c24-sticky #c24-header-bottom {
                    top: -2px;
                    position: absolute;
                }

                .c24-sticky .c24-mylists-icon-svg {
                    display: block;
                }

                .c24-sticky .c24-notification-icon svg {
                    height: 22px;
                }

                .c24-sticky .c24-contact {
                    padding-bottom: 0;
                    margin-top: 0;
                }

                .c24-sticky .c24-contact .c24-contact-content {
                    height: 44px;
                    margin-top: 4px;
                }

                .c24-sticky .c24-contact .c24-contact-icon {
                    width: 17px;
                    height: 23px;
                }

                .c24-sticky .c24-contact .c24-phone {
                    display: none;
                }

                .c24-sticky .c24-points-msg {
                    display: none;
                }

                .c24-responsive.c24-sticky .c24-mylists-icon {
                    padding-bottom: 0;
                }

                .c24-sticky .c24-cart-label {
                    display: none;
                } /* Cookie Layer */
                .c24-cookie {
                    width: 100%;
                    position: fixed;
                    left: 0;
                    bottom: -56px;
                    -webkit-transition:
                        visibility 0s,
                        bottom 300ms linear;
                    -o-transition:
                        visibility 0s,
                        bottom 300ms linear;
                    transition:
                        visibility 0s,
                        bottom 300ms linear;
                    background: rgba(4, 21, 60, 0.8);
                    z-index: 100000;
                }
                .c24-responsive .c24-cookie {
                    bottom: -120px;
                }
                .c24-cookie.c24-cookie-hide {
                    visibility: hidden;
                }
                .c24-cookie.c24-cookie-animate {
                    bottom: 0;
                    visibility: visible;
                }
                .c24-cookie-cnt {
                    min-width: 994px;
                    margin: 0 auto;
                    line-height: 20px;
                    position: relative;
                    max-width: 1310px;
                    width: 100%;
                    padding: 8px 15px;
                    box-sizing: border-box;
                }
                .c24-cookie-text {
                    color: #ffffff;
                    font-size: 12px;
                    display: inline-block;
                    float: left;
                }
                .c24-cookie-text a {
                    text-decoration: underline;
                    color: #ffffff;
                }
                .c24-cookie-button {
                    color: #ffffff;
                    font-size: 13px;
                    display: inline-block;
                    float: right;
                    line-height: 21px;
                    width: 105px;
                    padding: 5px 0;
                    margin-top: 4px;
                }

                /* Cookie Consent Screen */
                .c24-cookie-consent-notice *,
                .c24-cookie-consent-screen * {
                    -webkit-text-size-adjust: none !important;
                }

                .c24-cookie-consent-wrapper .c24-cc-logo {
                    margin: 0;
                    width: 130px;
                    height: 34px;
                    float: left;
                }

                .c24-cookie-consent-wrapper {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    position: fixed;
                    z-index: 20001;
                    visibility: hidden;
                }
                .c24-cookie-consent-notice:before,
                .c24-cookie-consent-screen:before {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-size: 100%;
                    background-repeat: no-repeat;
                    width: 96px;
                    height: 97px;
                    position: absolute;
                    top: -73px;
                    left: 227px;
                    content: ' ';
                }

                .c24-cookie-consent-notice,
                .c24-cookie-consent-screen {
                    background: rgba(4, 20, 60, 0.8);
                    border-radius: 5px;
                    padding: 30px 35px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    color: #ffffff;
                    width: 530px;
                    min-width: 530px;
                    max-width: 530px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-flow: column;
                    flex-flow: column;
                    visibility: hidden;
                    z-index: 20001;
                    position: relative;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-notice-title,
                .c24-cookie-consent-wrapper .c24-cookie-consent-screen-title {
                    margin-top: 0;
                    margin-bottom: 10px;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 24px;
                }

                .c24-cookie-consent-notice-cnt,
                .c24-cookie-consent-screen-cnt {
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                    -webkit-box-flex: 1;
                    -ms-flex-positive: 1;
                    flex-grow: 1;
                }

                .c24-cookie-consent-notice-cnt div,
                .c24-cookie-consent-screen-cnt div {
                    font-size: 16px;
                    line-height: 24px;
                }

                .c24-cookie-consent-notice a {
                    color: #ffffff;
                    text-decoration: underline;
                }

                .c24-cookie-consent-notice-text {
                    margin-bottom: 30px;
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                    -webkit-flex-shrink: 0;
                    -webkit-box-flex: 1;
                    -ms-flex-positive: 1;
                    flex-grow: 1;
                    -webkit-flex-grow: 1;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-imprint,
                .c24-cookie-consent-wrapper .c24-cookie-consent-backlink,
                .c24-cookie-consent-wrapper .c24-cookie-consent-functional {
                    color: #ffffff;
                    text-decoration: underline;
                    float: right;
                    font-size: 16px;
                    line-height: 30px;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-imprint {
                    line-height: 22px;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-functional,
                .c24-cookie-consent-wrapper .c24-cookie-consent-backlink {
                    line-height: 16px;
                }

                .c24-cookie-consent-notice-buttons,
                .c24-cookie-consent-screen-buttons {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                    -webkit-flex-shrink: 0;
                }

                .c24-cookie-consent-notice-buttons {
                    margin-bottom: 15px;
                }

                .c24-cookie-consent-screen-buttons {
                    margin-top: auto;
                    padding-top: 25px;
                }

                a.c24-cookie-consent-button {
                    text-decoration: none;
                    font-size: 18px;
                    color: #ffffff;
                    padding: 12px 0;
                    float: right;
                    width: 222px;
                    font-weight: normal;
                }

                a.c24-cookie-consent-button-secondary {
                    float: left;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    background: transparent;
                    border: 1px solid #dcdcdc !important;
                    padding: 11px 0;
                }

                .c24-cookie-consent-screen-list {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    max-height: 166px;
                    overflow-y: scroll;
                    border-top: 1px solid #ffffff;
                    border-bottom: 1px solid #ffffff;
                }

                .c24-cookie-consent-screen-list-entry {
                    padding: 15px 15px 15px 0;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-top: 1px solid #ffffff;
                }

                .c24-cookie-consent-screen-list-entry-header {
                    cursor: pointer;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                }

                .c24-cookie-consent-screen-list-entry:first-child {
                    border-top: none;
                }

                .c24-cookie-consent-screen-list-entry-header > div:nth-child(1) {
                    padding-right: 10px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                }

                .c24-cookie-consent-screen-list-entry-header > div:nth-child(2) {
                    padding-right: 10px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 1;
                    -ms-flex-positive: 1;
                    flex-grow: 1;
                    font-size: 16px;
                    line-height: 18px;
                    font-weight: 700;
                    cursor: pointer;
                }

                .c24-cookie-consent-screen-list-entry-header > div:nth-child(3) {
                    color: #333333;
                    width: 50px;
                }

                .c24-cookie-consent-screen-list-entry-header input[type='checkbox'] {
                    display: none;
                }

                .c24-cookie-consent-screen-list-entry-header div:first-child span:before {
                    content: '';
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    background: #ffffff;
                    border: 1px solid #999999;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 5px;
                }

                .c24-cookie-consent-screen-list-entry-header input[type='checkbox']:checked + span:before {
                    background: #ffffff url('https://www.check24.de/assets/images/web/svg/haken-darkblue.svg') no-repeat
                        center;
                    background-size: contain;
                    border: 1px solid #999999;
                    width: 18px;
                    height: 18px;
                }

                .c24-cookie-consent-screen-list-entry-header input[type='checkbox'][disabled]:checked + span:before {
                    background-color: #b4b4b4;
                    border: 1px solid #999999;
                }

                .c24-cookie-consent-button-more-icon {
                    display: block;
                    width: 14px;
                    height: 24px;
                    float: right;
                }

                .c24-cookie-consent-button-more-icon-open {
                    -webkit-transform: rotate(180deg);
                    -ms-transform: rotate(180deg);
                    transform: rotate(180deg);
                }

                .c24-cookie-consent-screen-list-entry-content {
                    display: none;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    line-height: 18px;
                    padding-top: 10px;
                }

                a.c24-cookie-consent-buttonlink {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    background: transparent !important;
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    float: left;
                    padding: 11px 0;
                    border: 1px solid #dcdcdc !important;
                }

                .c24-cookie-consent-wrapper ::-webkit-scrollbar {
                    width: 5px;
                    padding-left: 15px;
                }

                .c24-cookie-consent-wrapper ::-webkit-scrollbar-thumb {
                    background: #b4b4b4;
                }

                body.c24-cc-visible {
                    width: 100%;
                    position: fixed;
                    overflow-y: scroll;
                }

                .c24-cc-visible .c24-cookie-consent-wrapper {
                    visibility: visible;
                }

                .c24-cc-visible .c24-strict-blocking-layer {
                    display: block;
                }

                .c24-cc-visible .c24-cookie-consent-notice {
                    visibility: visible;
                }

                .c24-cc-visible .c24-cookie-consent-screen {
                    display: none;
                }

                .c24-cookie-consent-screen-list-m {
                    padding-left: 15px;
                }

                .c24-cookie-consent-screen-list-m-title {
                    font-weight: bold;
                    margin: 17px 0 15px;
                }

                .c24-cookie-consent-screen-list-m-entry {
                    margin-bottom: 15px;
                }

                .c24-cookie-consent-screen-list-m-entry
                    .c24-cookie-consent-screen-list-entry-header
                    > div:nth-child(2) {
                    line-height: 24px;
                    margin-top: -2px;
                }

                .c24-cookie-consent-screen-list-m-entry .c24-cookie-consent-button-more-icon {
                    margin-top: -2px;
                }

                .c24-cookie-consent-screen-list-m-entry .c24-cookie-consent-screen-list-entry-content {
                    padding-left: 29px;
                }

                a.c24-cookie-consent-cookielink,
                a.c24-cookie-consent-cookielink:hover {
                    color: #fff;
                    text-decoration: underline;
                }

                @media print {
                    .c24-cookie-consent-wrapper {
                        display: none;
                    }
                } /* ULI loginlayer */
                .c24-uli-loginlayer {
                    display: none;
                    background: #fff;
                    border: 1px solid #dcdcdc;
                    width: 500px;
                    position: absolute;
                    top: 100px;
                    left: 50%;
                    margin-left: -250px;
                    z-index: 20001;
                }

                .c24-uli-loginlayer-iframe {
                    width: 100%;
                    border: none;
                    -moz-user-select: none;
                    -webkit-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                    -o-user-select: none;
                    z-index: 20002;
                }

                .c24-uli-loginlayer-close {
                    position: absolute;
                    top: -30px;
                    right: 0;
                    height: 20px;
                    width: 20px;
                    background: url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj4NCjxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iODkuNywwIDUwLDM5LjYgMTAuMywwIDAsMTAuMyAzOS42LDUwIDAsODkuNyAxMC4zLDEwMCA1MCw2MC40IDg5LjcsMTAwIDEwMCw4OS43IDYwLjQsNTAgMTAwLDEwLjMiIC8+DQo8L3N2Zz4=')
                        no-repeat;
                    background-size: cover;
                    cursor: pointer;
                    z-index: 20003;
                    box-sizing: content-box;
                }

                .c24-uli-loginlayer-close:hover {
                    background: url('data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj4NCjxwb2x5Z29uIGZpbGw9IiM5OTk5OTkiIHBvaW50cz0iODkuNywwIDUwLDM5LjYgMTAuMywwIDAsMTAuMyAzOS42LDUwIDAsODkuNyAxMC4zLDEwMCA1MCw2MC40IDg5LjcsMTAwIDEwMCw4OS43IDYwLjQsNTAgMTAwLDEwLjMiIC8+DQo8L3N2Zz4=')
                        no-repeat;
                    background-size: cover;
                }
                .c24-contact-layer-chatbot {
                    width: 300px;
                }
                .c24-contact-layer-chatbot .c24-contact-title {
                    font-size: 15px;
                    color: #333333;
                    text-align: center;
                    margin: 5px 0 45px;
                    font-weight: bold;
                }
                .c24-contact-layer-chatbot .c24-contact-text-wrapper {
                    background: #f7f7f7;
                    border-radius: 17px;
                    padding: 40px 20px 14px;
                    font-size: 14px;
                    line-height: 18px;
                    color: #333333;
                    position: relative;
                    cursor: pointer;
                }
                .c24-contact-layer-chatbot .c24-contact-text {
                    white-space: normal;
                }
                .c24-contact-layer-chatbot .c24-contact-img {
                    height: 56px;
                    width: 56px;
                    border-radius: 28px;
                    position: absolute;
                    left: calc(50% - 30px);
                    top: -30px;
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NTAuMTc2IDU1MC4xNzYiPgogIDxjaXJjbGUgY3g9IjI3NS4wODgiIGN5PSIyNzUuMDg4IiByPSIyNzUuMDg4IiBmaWxsPSIjZDNlY2ViIiAvPgogIDxnPgogICAgPHBhdGggZD0iTTMzMC4xNSwxOTguMzcxbDIwLjMwNCw2OC40OTJjNS42NTgsMTkuMDg4LDIwLjU4OSwzNC4wMTgsMzkuNjc3LDM5LjY3N2w2OC40OTIsMjAuMzA0YzcuMTg3LDIuMTMxLDcuMTg3LDEyLjMwOSwwLDE0LjQzOWwtNjguNDkyLDIwLjMwNGMtMTkuMDg4LDUuNjU4LTM0LjAxOCwyMC41ODktMzkuNjc3LDM5LjY3N2wtMjAuMzA0LDY4LjQ5MmMtMi4xMzEsNy4xODctMTIuMzA5LDcuMTg3LTE0LjQzOSwwbC0yMC4zMDQtNjguNDkyYy01LjY1OC0xOS4wODgtMjAuNTg5LTM0LjAxOC0zOS42NzctMzkuNjc3bC02OC40OTEtMjAuMzA0Yy03LjE4Ny0yLjEzMS03LjE4Ny0xMi4zMDksMC0xNC40MzlsNjguNDkyLTIwLjMwNGMxOS4wODgtNS42NTgsMzQuMDE4LTIwLjU4OSwzOS42NzctMzkuNjc3bDIwLjMwMy02OC40OTFjMi4xMzEtNy4xODcsMTIuMzA5LTcuMTg3LDE0LjQzOSwwaDBaIiBmaWxsPSIjMDA1YzYxIiBzdHJva2Utd2lkdGg9IjAiLz4KICAgIDxwYXRoIGQ9Ik0xODIuNTY4LDg0LjE2OWwxMS44MywzOS45MDZjMy4yOTcsMTEuMTIyLDExLjk5NiwxOS44MiwyMy4xMTcsMjMuMTE3bDM5LjkwNiwxMS44M2M0LjE4NywxLjI0MSw0LjE4Nyw3LjE3MiwwLDguNDEzbC0zOS45MDYsMTEuODNjLTExLjEyMiwzLjI5Ny0xOS44MiwxMS45OTYtMjMuMTE3LDIzLjExN2wtMTEuODMsMzkuOTA2Yy0xLjI0MSw0LjE4Ny03LjE3Miw0LjE4Ny04LjQxMywwbC0xMS44My0zOS45MDZjLTMuMjk3LTExLjEyMi0xMS45OTYtMTkuODItMjMuMTE3LTIzLjExN2wtMzkuOTA2LTExLjgzYy00LjE4Ny0xLjI0MS00LjE4Ny03LjE3MiwwLTguNDEzbDM5LjkwNi0xMS44M2MxMS4xMjItMy4yOTcsMTkuODItMTEuOTk2LDIzLjExNy0yMy4xMTdsMTEuODMtMzkuOTA2YzEuMjQxLTQuMTg3LDcuMTcyLTQuMTg3LDguNDEzLDBaIiBmaWxsPSIjMDA1YzYxIiBzdHJva2Utd2lkdGg9IjAiLz4KICA8L2c+Cjwvc3ZnPg==');
                    background-size: 100%;
                }
                .c24-contact-layer-chatbot .c24-chatbot-open {
                    color: #0563c1;
                    text-align: right;
                    margin-top: 5px;
                }
                .c24-contact-layer-chatbot .c24-contact-text-wrapper:hover .c24-chatbot-open {
                    text-decoration: underline;
                }
                .c24-contact-layer-chatbot a.c24-contact-layer-link,
                .c24-contact-layer-chatbot a.c24-contact-layer-link:hover {
                    display: block;
                    margin: 15px 0 5px;
                    font-size: 14px;
                    text-align: center;
                    color: #333333;
                    text-decoration: none;
                }
                .c24-contact-layer-chatbot a.c24-contact-layer-link span {
                    color: #0563c1;
                }
                .c24-contact-layer-chatbot a.c24-contact-layer-link:hover span {
                    text-decoration: underline;
                }
                .c24-chatbot-button {
                    position: fixed;
                    z-index: 30;
                    bottom: 24px;
                    right: 24px;
                    height: 62px;
                    width: 62px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: #ffffff;
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NS4yMDIgODMuMjg5Ij4KICAgIDxwYXRoIGQ9Ik00Ni45MTMsMjQuNzk4bDQuMjkxLDE0LjQ3NGMxLjE5Niw0LjAzNCw0LjM1MSw3LjE4OSw4LjM4NSw4LjM4NWwxNC40NzQsNC4yOTFjMS41MTkuNDUsMS41MTksMi42MDEsMCwzLjA1MWwtMTQuNDc0LDQuMjkxYy00LjAzNCwxLjE5Ni03LjE4OSw0LjM1MS04LjM4NSw4LjM4NWwtNC4yOTEsMTQuNDc0Yy0uNDUsMS41MTktMi42MDEsMS41MTktMy4wNTEsMGwtNC4yOTEtMTQuNDc0Yy0xLjE5Ni00LjAzNC00LjM1MS03LjE4OS04LjM4NS04LjM4NWwtMTQuNDc0LTQuMjkxYy0xLjUxOS0uNDUtMS41MTktMi42MDEsMC0zLjA1MWwxNC40NzQtNC4yOTFjNC4wMzQtMS4xOTYsNy4xODktNC4zNTEsOC4zODUtOC4zODVsNC4yOTEtMTQuNDc0Yy40NS0xLjUxOSwyLjYwMS0xLjUxOSwzLjA1MSwwaDBaIiBmaWxsPSIjMDA1YzYxIiAvPgogICAgPHBhdGggZD0iTTE4LjI2LjY2NGwyLjUsOC40MzNjLjY5NywyLjM1LDIuNTM1LDQuMTg5LDQuODg1LDQuODg1bDguNDMzLDIuNWMuODg1LjI2Mi44ODUsMS41MTYsMCwxLjc3OGwtOC40MzMsMi41Yy0yLjM1LjY5Ny00LjE4OSwyLjUzNS00Ljg4NSw0Ljg4NWwtMi41LDguNDMzYy0uMjYyLjg4NS0xLjUxNi44ODUtMS43NzgsMGwtMi41LTguNDMzYy0uNjk3LTIuMzUtMi41MzUtNC4xODktNC44ODUtNC44ODVMLjY2NCwxOC4yNmMtLjg4NS0uMjYyLS44ODUtMS41MTYsMC0xLjc3OGw4LjQzMy0yLjVjMi4zNS0uNjk3LDQuMTg5LTIuNTM1LDQuODg1LTQuODg1TDE2LjQ4Mi42NjRjLjI2Mi0uODg1LDEuNTE2LS44ODUsMS43NzgsMFoiIGZpbGw9IiNmMDdjMDAiIC8+Cjwvc3ZnPg==');
                    background-size: 26px;
                    background-position: center 8px;
                    background-repeat: no-repeat;
                    box-shadow:
                        0 2px 4px rgba(0, 0, 0, 0.1),
                        0 0 10px rgba(0, 0, 0, 0.2);
                    cursor: pointer;
                }
                .c24-chatbot-button-text {
                    font-size: 10px;
                    width: 100%;
                    text-align: center;
                    position: absolute;
                    bottom: 8px;
                }
                #Chatbot-wrapper {
                    z-index: var(--z-index-wireframeChatty) !important;
                }
                #Chatbot-wrapper .ActivityAnswerMessage__content-box * {
                    box-sizing: unset;
                }
                #Chatbot-wrapper .button {
                    font-family: unset;
                    padding: unset;
                    width: unset;
                }
                .c24-uli-loginlayer {
                    z-index: var(--z-index-wireframeUliLoginLayer);
                }
                .ScrollArrow_button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .c24-cookie-consent-wrapper {
                    z-index: var(--z-index-wireframeCookieConsentWrapper) !important;
                }
            `}</style>
        </>
    );
}
